import _r from "react";
import { c as Xe, g as Mt } from "./plotly-vendor-Xl9RTeYD.js";
var mn = { exports: {} }, ze = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yn;
function Rr() {
  if (Yn) return ze;
  Yn = 1;
  var e = Symbol.for("react.transitional.element"), n = Symbol.for("react.fragment");
  function t(r, i, l) {
    var o = null;
    if (l !== void 0 && (o = "" + l), i.key !== void 0 && (o = "" + i.key), "key" in i) {
      l = {};
      for (var a in i)
        a !== "key" && (l[a] = i[a]);
    } else l = i;
    return i = l.ref, {
      $$typeof: e,
      type: r,
      key: o,
      ref: i !== void 0 ? i : null,
      props: l
    };
  }
  return ze.Fragment = n, ze.jsx = t, ze.jsxs = t, ze;
}
var Le = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wn;
function Or() {
  return Wn || (Wn = 1, process.env.NODE_ENV !== "production" && function() {
    function e(u) {
      if (u == null) return null;
      if (typeof u == "function")
        return u.$$typeof === j ? null : u.displayName || u.name || null;
      if (typeof u == "string") return u;
      switch (u) {
        case k:
          return "Fragment";
        case w:
          return "Profiler";
        case I:
          return "StrictMode";
        case O:
          return "Suspense";
        case x:
          return "SuspenseList";
        case B:
          return "Activity";
      }
      if (typeof u == "object")
        switch (typeof u.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), u.$$typeof) {
          case y:
            return "Portal";
          case E:
            return (u.displayName || "Context") + ".Provider";
          case C:
            return (u._context.displayName || "Context") + ".Consumer";
          case N:
            var P = u.render;
            return u = u.displayName, u || (u = P.displayName || P.name || "", u = u !== "" ? "ForwardRef(" + u + ")" : "ForwardRef"), u;
          case D:
            return P = u.displayName || null, P !== null ? P : e(u.type) || "Memo";
          case W:
            P = u._payload, u = u._init;
            try {
              return e(u(P));
            } catch {
            }
        }
      return null;
    }
    function n(u) {
      return "" + u;
    }
    function t(u) {
      try {
        n(u);
        var P = !1;
      } catch {
        P = !0;
      }
      if (P) {
        P = console;
        var F = P.error, m = typeof Symbol == "function" && Symbol.toStringTag && u[Symbol.toStringTag] || u.constructor.name || "Object";
        return F.call(
          P,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          m
        ), n(u);
      }
    }
    function r(u) {
      if (u === k) return "<>";
      if (typeof u == "object" && u !== null && u.$$typeof === W)
        return "<...>";
      try {
        var P = e(u);
        return P ? "<" + P + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function i() {
      var u = A.A;
      return u === null ? null : u.getOwner();
    }
    function l() {
      return Error("react-stack-top-frame");
    }
    function o(u) {
      if (T.call(u, "key")) {
        var P = Object.getOwnPropertyDescriptor(u, "key").get;
        if (P && P.isReactWarning) return !1;
      }
      return u.key !== void 0;
    }
    function a(u, P) {
      function F() {
        z || (z = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          P
        ));
      }
      F.isReactWarning = !0, Object.defineProperty(u, "key", {
        get: F,
        configurable: !0
      });
    }
    function s() {
      var u = e(this.type);
      return K[u] || (K[u] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), u = this.props.ref, u !== void 0 ? u : null;
    }
    function c(u, P, F, m, Q, Z, X, ge) {
      return F = Z.ref, u = {
        $$typeof: p,
        type: u,
        key: P,
        props: Z,
        _owner: Q
      }, (F !== void 0 ? F : null) !== null ? Object.defineProperty(u, "ref", {
        enumerable: !1,
        get: s
      }) : Object.defineProperty(u, "ref", { enumerable: !1, value: null }), u._store = {}, Object.defineProperty(u._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(u, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(u, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: X
      }), Object.defineProperty(u, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: ge
      }), Object.freeze && (Object.freeze(u.props), Object.freeze(u)), u;
    }
    function f(u, P, F, m, Q, Z, X, ge) {
      var $ = P.children;
      if ($ !== void 0)
        if (m)
          if (H($)) {
            for (m = 0; m < $.length; m++)
              h($[m]);
            Object.freeze && Object.freeze($);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else h($);
      if (T.call(P, "key")) {
        $ = e(u);
        var le = Object.keys(P).filter(function(Ce) {
          return Ce !== "key";
        });
        m = 0 < le.length ? "{key: someKey, " + le.join(": ..., ") + ": ...}" : "{key: someKey}", se[$ + m] || (le = 0 < le.length ? "{" + le.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          m,
          $,
          le,
          $
        ), se[$ + m] = !0);
      }
      if ($ = null, F !== void 0 && (t(F), $ = "" + F), o(P) && (t(P.key), $ = "" + P.key), "key" in P) {
        F = {};
        for (var pe in P)
          pe !== "key" && (F[pe] = P[pe]);
      } else F = P;
      return $ && a(
        F,
        typeof u == "function" ? u.displayName || u.name || "Unknown" : u
      ), c(
        u,
        $,
        Z,
        Q,
        i(),
        F,
        X,
        ge
      );
    }
    function h(u) {
      typeof u == "object" && u !== null && u.$$typeof === p && u._store && (u._store.validated = 1);
    }
    var d = _r, p = Symbol.for("react.transitional.element"), y = Symbol.for("react.portal"), k = Symbol.for("react.fragment"), I = Symbol.for("react.strict_mode"), w = Symbol.for("react.profiler"), C = Symbol.for("react.consumer"), E = Symbol.for("react.context"), N = Symbol.for("react.forward_ref"), O = Symbol.for("react.suspense"), x = Symbol.for("react.suspense_list"), D = Symbol.for("react.memo"), W = Symbol.for("react.lazy"), B = Symbol.for("react.activity"), j = Symbol.for("react.client.reference"), A = d.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, T = Object.prototype.hasOwnProperty, H = Array.isArray, Y = console.createTask ? console.createTask : function() {
      return null;
    };
    d = {
      react_stack_bottom_frame: function(u) {
        return u();
      }
    };
    var z, K = {}, G = d.react_stack_bottom_frame.bind(
      d,
      l
    )(), ne = Y(r(l)), se = {};
    Le.Fragment = k, Le.jsx = function(u, P, F, m, Q) {
      var Z = 1e4 > A.recentlyCreatedOwnerStacks++;
      return f(
        u,
        P,
        F,
        !1,
        m,
        Q,
        Z ? Error("react-stack-top-frame") : G,
        Z ? Y(r(u)) : ne
      );
    }, Le.jsxs = function(u, P, F, m, Q) {
      var Z = 1e4 > A.recentlyCreatedOwnerStacks++;
      return f(
        u,
        P,
        F,
        !0,
        m,
        Q,
        Z ? Error("react-stack-top-frame") : G,
        Z ? Y(r(u)) : ne
      );
    };
  }()), Le;
}
process.env.NODE_ENV === "production" ? mn.exports = Rr() : mn.exports = Or();
var nn = mn.exports;
function zr(e, n) {
  const t = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (t.padRight ? " " : "") + "," + (t.padLeft === !1 ? "" : " ")
  ).trim();
}
const Lr = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, Nr = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, Dr = {};
function Xn(e, n) {
  return (Dr.jsx ? Nr : Lr).test(e);
}
const Fr = /[ \t\n\f\r]/g;
function Mr(e) {
  return typeof e == "object" ? e.type === "text" ? Gn(e.value) : !1 : Gn(e);
}
function Gn(e) {
  return e.replace(Fr, "") === "";
}
class Ue {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(n, t, r) {
    this.normal = t, this.property = n, r && (this.space = r);
  }
}
Ue.prototype.normal = {};
Ue.prototype.property = {};
Ue.prototype.space = void 0;
function Bt(e, n) {
  const t = {}, r = {};
  for (const i of e)
    Object.assign(t, i.property), Object.assign(r, i.normal);
  return new Ue(t, r, n);
}
function dn(e) {
  return e.toLowerCase();
}
class ie {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(n, t) {
    this.attribute = t, this.property = n;
  }
}
ie.prototype.attribute = "";
ie.prototype.booleanish = !1;
ie.prototype.boolean = !1;
ie.prototype.commaOrSpaceSeparated = !1;
ie.prototype.commaSeparated = !1;
ie.prototype.defined = !1;
ie.prototype.mustUseProperty = !1;
ie.prototype.number = !1;
ie.prototype.overloadedBoolean = !1;
ie.prototype.property = "";
ie.prototype.spaceSeparated = !1;
ie.prototype.space = void 0;
let Br = 0;
const R = Ee(), J = Ee(), gn = Ee(), b = Ee(), V = Ee(), Ae = Ee(), ae = Ee();
function Ee() {
  return 2 ** ++Br;
}
const yn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: R,
  booleanish: J,
  commaOrSpaceSeparated: ae,
  commaSeparated: Ae,
  number: b,
  overloadedBoolean: gn,
  spaceSeparated: V
}, Symbol.toStringTag, { value: "Module" })), tn = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(yn)
);
class Tn extends ie {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(n, t, r, i) {
    let l = -1;
    if (super(n, t), Qn(this, "space", i), typeof r == "number")
      for (; ++l < tn.length; ) {
        const o = tn[l];
        Qn(this, tn[l], (r & yn[o]) === yn[o]);
      }
  }
}
Tn.prototype.defined = !0;
function Qn(e, n, t) {
  t && (e[n] = t);
}
function ve(e) {
  const n = {}, t = {};
  for (const [r, i] of Object.entries(e.properties)) {
    const l = new Tn(
      r,
      e.transform(e.attributes || {}, r),
      i,
      e.space
    );
    e.mustUseProperty && e.mustUseProperty.includes(r) && (l.mustUseProperty = !0), n[r] = l, t[dn(r)] = r, t[dn(l.attribute)] = r;
  }
  return new Ue(n, t, e.space);
}
const jt = ve({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: J,
    ariaAutoComplete: null,
    ariaBusy: J,
    ariaChecked: J,
    ariaColCount: b,
    ariaColIndex: b,
    ariaColSpan: b,
    ariaControls: V,
    ariaCurrent: null,
    ariaDescribedBy: V,
    ariaDetails: null,
    ariaDisabled: J,
    ariaDropEffect: V,
    ariaErrorMessage: null,
    ariaExpanded: J,
    ariaFlowTo: V,
    ariaGrabbed: J,
    ariaHasPopup: null,
    ariaHidden: J,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: V,
    ariaLevel: b,
    ariaLive: null,
    ariaModal: J,
    ariaMultiLine: J,
    ariaMultiSelectable: J,
    ariaOrientation: null,
    ariaOwns: V,
    ariaPlaceholder: null,
    ariaPosInSet: b,
    ariaPressed: J,
    ariaReadOnly: J,
    ariaRelevant: null,
    ariaRequired: J,
    ariaRoleDescription: V,
    ariaRowCount: b,
    ariaRowIndex: b,
    ariaRowSpan: b,
    ariaSelected: J,
    ariaSetSize: b,
    ariaSort: null,
    ariaValueMax: b,
    ariaValueMin: b,
    ariaValueNow: b,
    ariaValueText: null,
    role: null
  },
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  }
});
function Ut(e, n) {
  return n in e ? e[n] : n;
}
function Ht(e, n) {
  return Ut(e, n.toLowerCase());
}
const jr = ve({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Ae,
    acceptCharset: V,
    accessKey: V,
    action: null,
    allow: null,
    allowFullScreen: R,
    allowPaymentRequest: R,
    allowUserMedia: R,
    alt: null,
    as: null,
    async: R,
    autoCapitalize: null,
    autoComplete: V,
    autoFocus: R,
    autoPlay: R,
    blocking: V,
    capture: null,
    charSet: null,
    checked: R,
    cite: null,
    className: V,
    cols: b,
    colSpan: null,
    content: null,
    contentEditable: J,
    controls: R,
    controlsList: V,
    coords: b | Ae,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: R,
    defer: R,
    dir: null,
    dirName: null,
    disabled: R,
    download: gn,
    draggable: J,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: R,
    formTarget: null,
    headers: V,
    height: b,
    hidden: gn,
    high: b,
    href: null,
    hrefLang: null,
    htmlFor: V,
    httpEquiv: V,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: R,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: R,
    itemId: null,
    itemProp: V,
    itemRef: V,
    itemScope: R,
    itemType: V,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: R,
    low: b,
    manifest: null,
    max: null,
    maxLength: b,
    media: null,
    method: null,
    min: null,
    minLength: b,
    multiple: R,
    muted: R,
    name: null,
    nonce: null,
    noModule: R,
    noValidate: R,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: R,
    optimum: b,
    pattern: null,
    ping: V,
    placeholder: null,
    playsInline: R,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: R,
    referrerPolicy: null,
    rel: V,
    required: R,
    reversed: R,
    rows: b,
    rowSpan: b,
    sandbox: V,
    scope: null,
    scoped: R,
    seamless: R,
    selected: R,
    shadowRootClonable: R,
    shadowRootDelegatesFocus: R,
    shadowRootMode: null,
    shape: null,
    size: b,
    sizes: null,
    slot: null,
    span: b,
    spellCheck: J,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: b,
    step: null,
    style: null,
    tabIndex: b,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: R,
    useMap: null,
    value: J,
    width: b,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: V,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: b,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: b,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: R,
    // Lists. Use CSS to reduce space between items instead
    declare: R,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: b,
    // `<img>` and `<object>`
    leftMargin: b,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: b,
    // `<body>`
    marginWidth: b,
    // `<body>`
    noResize: R,
    // `<frame>`
    noHref: R,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: R,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: R,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: b,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: J,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: b,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: b,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: R,
    disableRemotePlayback: R,
    prefix: null,
    property: null,
    results: b,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: Ht
}), Ur = ve({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: ae,
    accentHeight: b,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: b,
    amplitude: b,
    arabicForm: null,
    ascent: b,
    attributeName: null,
    attributeType: null,
    azimuth: b,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: b,
    by: null,
    calcMode: null,
    capHeight: b,
    className: V,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: b,
    diffuseConstant: b,
    direction: null,
    display: null,
    dur: null,
    divisor: b,
    dominantBaseline: null,
    download: R,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: b,
    enableBackground: null,
    end: null,
    event: null,
    exponent: b,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: b,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Ae,
    g2: Ae,
    glyphName: Ae,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: b,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: b,
    horizOriginX: b,
    horizOriginY: b,
    id: null,
    ideographic: b,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: b,
    k: b,
    k1: b,
    k2: b,
    k3: b,
    k4: b,
    kernelMatrix: ae,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: b,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: b,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: b,
    overlineThickness: b,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: b,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: V,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: b,
    pointsAtY: b,
    pointsAtZ: b,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: ae,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: ae,
    rev: ae,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: ae,
    requiredFeatures: ae,
    requiredFonts: ae,
    requiredFormats: ae,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: b,
    specularExponent: b,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: b,
    strikethroughThickness: b,
    string: null,
    stroke: null,
    strokeDashArray: ae,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: b,
    strokeOpacity: b,
    strokeWidth: null,
    style: null,
    surfaceScale: b,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: ae,
    tabIndex: b,
    tableValues: null,
    target: null,
    targetX: b,
    targetY: b,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: ae,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: b,
    underlineThickness: b,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: b,
    values: null,
    vAlphabetic: b,
    vMathematical: b,
    vectorEffect: null,
    vHanging: b,
    vIdeographic: b,
    version: null,
    vertAdvY: b,
    vertOriginX: b,
    vertOriginY: b,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: b,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: Ut
}), Vt = ve({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  }
}), qt = ve({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: Ht
}), $t = ve({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  }
}), Hr = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, Vr = /[A-Z]/g, Jn = /-[a-z]/g, qr = /^data[-\w.:]+$/i;
function $r(e, n) {
  const t = dn(n);
  let r = n, i = ie;
  if (t in e.normal)
    return e.property[e.normal[t]];
  if (t.length > 4 && t.slice(0, 4) === "data" && qr.test(n)) {
    if (n.charAt(4) === "-") {
      const l = n.slice(5).replace(Jn, Wr);
      r = "data" + l.charAt(0).toUpperCase() + l.slice(1);
    } else {
      const l = n.slice(4);
      if (!Jn.test(l)) {
        let o = l.replace(Vr, Yr);
        o.charAt(0) !== "-" && (o = "-" + o), n = "data" + o;
      }
    }
    i = Tn;
  }
  return new i(r, n);
}
function Yr(e) {
  return "-" + e.toLowerCase();
}
function Wr(e) {
  return e.charAt(1).toUpperCase();
}
const Xr = Bt([jt, jr, Vt, qt, $t], "html"), An = Bt([jt, Ur, Vt, qt, $t], "svg");
function Gr(e) {
  return e.join(" ").trim();
}
var Pn = {}, Kn = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, Qr = /\n/g, Jr = /^\s*/, Kr = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, Zr = /^:\s*/, ei = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, ni = /^[;\s]*/, ti = /^\s+|\s+$/g, ri = `
`, Zn = "/", et = "*", Se = "", ii = "comment", li = "declaration", oi = function(e, n) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e) return [];
  n = n || {};
  var t = 1, r = 1;
  function i(y) {
    var k = y.match(Qr);
    k && (t += k.length);
    var I = y.lastIndexOf(ri);
    r = ~I ? y.length - I : r + y.length;
  }
  function l() {
    var y = { line: t, column: r };
    return function(k) {
      return k.position = new o(y), c(), k;
    };
  }
  function o(y) {
    this.start = y, this.end = { line: t, column: r }, this.source = n.source;
  }
  o.prototype.content = e;
  function a(y) {
    var k = new Error(
      n.source + ":" + t + ":" + r + ": " + y
    );
    if (k.reason = y, k.filename = n.source, k.line = t, k.column = r, k.source = e, !n.silent) throw k;
  }
  function s(y) {
    var k = y.exec(e);
    if (k) {
      var I = k[0];
      return i(I), e = e.slice(I.length), k;
    }
  }
  function c() {
    s(Jr);
  }
  function f(y) {
    var k;
    for (y = y || []; k = h(); )
      k !== !1 && y.push(k);
    return y;
  }
  function h() {
    var y = l();
    if (!(Zn != e.charAt(0) || et != e.charAt(1))) {
      for (var k = 2; Se != e.charAt(k) && (et != e.charAt(k) || Zn != e.charAt(k + 1)); )
        ++k;
      if (k += 2, Se === e.charAt(k - 1))
        return a("End of comment missing");
      var I = e.slice(2, k - 2);
      return r += 2, i(I), e = e.slice(k), r += 2, y({
        type: ii,
        comment: I
      });
    }
  }
  function d() {
    var y = l(), k = s(Kr);
    if (k) {
      if (h(), !s(Zr)) return a("property missing ':'");
      var I = s(ei), w = y({
        type: li,
        property: nt(k[0].replace(Kn, Se)),
        value: I ? nt(I[0].replace(Kn, Se)) : Se
      });
      return s(ni), w;
    }
  }
  function p() {
    var y = [];
    f(y);
    for (var k; k = d(); )
      k !== !1 && (y.push(k), f(y));
    return y;
  }
  return c(), p();
};
function nt(e) {
  return e ? e.replace(ti, Se) : Se;
}
var ai = Xe && Xe.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Pn, "__esModule", { value: !0 });
Pn.default = si;
var ui = ai(oi);
function si(e, n) {
  var t = null;
  if (!e || typeof e != "string")
    return t;
  var r = (0, ui.default)(e), i = typeof n == "function";
  return r.forEach(function(l) {
    if (l.type === "declaration") {
      var o = l.property, a = l.value;
      i ? n(o, a, l) : a && (t = t || {}, t[o] = a);
    }
  }), t;
}
var Je = {};
Object.defineProperty(Je, "__esModule", { value: !0 });
Je.camelCase = void 0;
var ci = /^--[a-zA-Z0-9_-]+$/, fi = /-([a-z])/g, pi = /^[^-]+$/, hi = /^-(webkit|moz|ms|o|khtml)-/, mi = /^-(ms)-/, di = function(e) {
  return !e || pi.test(e) || ci.test(e);
}, gi = function(e, n) {
  return n.toUpperCase();
}, tt = function(e, n) {
  return "".concat(n, "-");
}, yi = function(e, n) {
  return n === void 0 && (n = {}), di(e) ? e : (e = e.toLowerCase(), n.reactCompat ? e = e.replace(mi, tt) : e = e.replace(hi, tt), e.replace(fi, gi));
};
Je.camelCase = yi;
var xi = Xe && Xe.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
}, ki = xi(Pn), bi = Je;
function xn(e, n) {
  var t = {};
  return !e || typeof e != "string" || (0, ki.default)(e, function(r, i) {
    r && i && (t[(0, bi.camelCase)(r, n)] = i);
  }), t;
}
xn.default = xn;
var wi = xn;
const Si = /* @__PURE__ */ Mt(wi), Yt = Wt("end"), vn = Wt("start");
function Wt(e) {
  return n;
  function n(t) {
    const r = t && t.position && t.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function Ei(e) {
  const n = vn(e), t = Yt(e);
  if (n && t)
    return { start: n, end: t };
}
function Fe(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? rt(e.position) : "start" in e || "end" in e ? rt(e) : "line" in e || "column" in e ? kn(e) : "";
}
function kn(e) {
  return it(e && e.line) + ":" + it(e && e.column);
}
function rt(e) {
  return kn(e && e.start) + "-" + kn(e && e.end);
}
function it(e) {
  return e && typeof e == "number" ? e : 1;
}
class ee extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, t, r) {
    super(), typeof t == "string" && (r = t, t = void 0);
    let i = "", l = {}, o = !1;
    if (t && ("line" in t && "column" in t ? l = { place: t } : "start" in t && "end" in t ? l = { place: t } : "type" in t ? l = {
      ancestors: [t],
      place: t.position
    } : l = { ...t }), typeof n == "string" ? i = n : !l.cause && n && (o = !0, i = n.message, l.cause = n), !l.ruleId && !l.source && typeof r == "string") {
      const s = r.indexOf(":");
      s === -1 ? l.ruleId = r : (l.source = r.slice(0, s), l.ruleId = r.slice(s + 1));
    }
    if (!l.place && l.ancestors && l.ancestors) {
      const s = l.ancestors[l.ancestors.length - 1];
      s && (l.place = s.position);
    }
    const a = l.place && "start" in l.place ? l.place.start : l.place;
    this.ancestors = l.ancestors || void 0, this.cause = l.cause || void 0, this.column = a ? a.column : void 0, this.fatal = void 0, this.file, this.message = i, this.line = a ? a.line : void 0, this.name = Fe(l.place) || "1:1", this.place = l.place || void 0, this.reason = this.message, this.ruleId = l.ruleId || void 0, this.source = l.source || void 0, this.stack = o && l.cause && typeof l.cause.stack == "string" ? l.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
ee.prototype.file = "";
ee.prototype.name = "";
ee.prototype.reason = "";
ee.prototype.message = "";
ee.prototype.stack = "";
ee.prototype.column = void 0;
ee.prototype.line = void 0;
ee.prototype.ancestors = void 0;
ee.prototype.cause = void 0;
ee.prototype.fatal = void 0;
ee.prototype.place = void 0;
ee.prototype.ruleId = void 0;
ee.prototype.source = void 0;
const _n = {}.hasOwnProperty, Ci = /* @__PURE__ */ new Map(), Ii = /[A-Z]/g, Ti = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), Ai = /* @__PURE__ */ new Set(["td", "th"]), Xt = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function Pi(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const t = n.filePath || void 0;
  let r;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = Di(t, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = Ni(t, n.jsx, n.jsxs);
  }
  const i = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: r,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: t,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? An : Xr,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, l = Gt(i, e, void 0);
  return l && typeof l != "string" ? l : i.create(
    e,
    i.Fragment,
    { children: l || void 0 },
    void 0
  );
}
function Gt(e, n, t) {
  if (n.type === "element")
    return vi(e, n, t);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return _i(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return Oi(e, n, t);
  if (n.type === "mdxjsEsm")
    return Ri(e, n);
  if (n.type === "root")
    return zi(e, n, t);
  if (n.type === "text")
    return Li(e, n);
}
function vi(e, n, t) {
  const r = e.schema;
  let i = r;
  n.tagName.toLowerCase() === "svg" && r.space === "html" && (i = An, e.schema = i), e.ancestors.push(n);
  const l = Jt(e, n.tagName, !1), o = Fi(e, n);
  let a = On(e, n);
  return Ti.has(n.tagName) && (a = a.filter(function(s) {
    return typeof s == "string" ? !Mr(s) : !0;
  })), Qt(e, o, l, n), Rn(o, a), e.ancestors.pop(), e.schema = r, e.create(n, l, o, t);
}
function _i(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const r = n.data.estree.body[0];
    return r.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(r.expression);
  }
  je(e, n.position);
}
function Ri(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  je(e, n.position);
}
function Oi(e, n, t) {
  const r = e.schema;
  let i = r;
  n.name === "svg" && r.space === "html" && (i = An, e.schema = i), e.ancestors.push(n);
  const l = n.name === null ? e.Fragment : Jt(e, n.name, !0), o = Mi(e, n), a = On(e, n);
  return Qt(e, o, l, n), Rn(o, a), e.ancestors.pop(), e.schema = r, e.create(n, l, o, t);
}
function zi(e, n, t) {
  const r = {};
  return Rn(r, On(e, n)), e.create(n, e.Fragment, r, t);
}
function Li(e, n) {
  return n.value;
}
function Qt(e, n, t, r) {
  typeof t != "string" && t !== e.Fragment && e.passNode && (n.node = r);
}
function Rn(e, n) {
  if (n.length > 0) {
    const t = n.length > 1 ? n : n[0];
    t && (e.children = t);
  }
}
function Ni(e, n, t) {
  return r;
  function r(i, l, o, a) {
    const c = Array.isArray(o.children) ? t : n;
    return a ? c(l, o, a) : c(l, o);
  }
}
function Di(e, n) {
  return t;
  function t(r, i, l, o) {
    const a = Array.isArray(l.children), s = vn(r);
    return n(
      i,
      l,
      o,
      a,
      {
        columnNumber: s ? s.column - 1 : void 0,
        fileName: e,
        lineNumber: s ? s.line : void 0
      },
      void 0
    );
  }
}
function Fi(e, n) {
  const t = {};
  let r, i;
  for (i in n.properties)
    if (i !== "children" && _n.call(n.properties, i)) {
      const l = Bi(e, i, n.properties[i]);
      if (l) {
        const [o, a] = l;
        e.tableCellAlignToStyle && o === "align" && typeof a == "string" && Ai.has(n.tagName) ? r = a : t[o] = a;
      }
    }
  if (r) {
    const l = (
      /** @type {Style} */
      t.style || (t.style = {})
    );
    l[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return t;
}
function Mi(e, n) {
  const t = {};
  for (const r of n.attributes)
    if (r.type === "mdxJsxExpressionAttribute")
      if (r.data && r.data.estree && e.evaluater) {
        const l = r.data.estree.body[0];
        l.type;
        const o = l.expression;
        o.type;
        const a = o.properties[0];
        a.type, Object.assign(
          t,
          e.evaluater.evaluateExpression(a.argument)
        );
      } else
        je(e, n.position);
    else {
      const i = r.name;
      let l;
      if (r.value && typeof r.value == "object")
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const a = r.value.data.estree.body[0];
          a.type, l = e.evaluater.evaluateExpression(a.expression);
        } else
          je(e, n.position);
      else
        l = r.value === null ? !0 : r.value;
      t[i] = /** @type {Props[keyof Props]} */
      l;
    }
  return t;
}
function On(e, n) {
  const t = [];
  let r = -1;
  const i = e.passKeys ? /* @__PURE__ */ new Map() : Ci;
  for (; ++r < n.children.length; ) {
    const l = n.children[r];
    let o;
    if (e.passKeys) {
      const s = l.type === "element" ? l.tagName : l.type === "mdxJsxFlowElement" || l.type === "mdxJsxTextElement" ? l.name : void 0;
      if (s) {
        const c = i.get(s) || 0;
        o = s + "-" + c, i.set(s, c + 1);
      }
    }
    const a = Gt(e, l, o);
    a !== void 0 && t.push(a);
  }
  return t;
}
function Bi(e, n, t) {
  const r = $r(e.schema, n);
  if (!(t == null || typeof t == "number" && Number.isNaN(t))) {
    if (Array.isArray(t) && (t = r.commaSeparated ? zr(t) : Gr(t)), r.property === "style") {
      let i = typeof t == "object" ? t : ji(e, String(t));
      return e.stylePropertyNameCase === "css" && (i = Ui(i)), ["style", i];
    }
    return [
      e.elementAttributeNameCase === "react" && r.space ? Hr[r.property] || r.property : r.attribute,
      t
    ];
  }
}
function ji(e, n) {
  try {
    return Si(n, { reactCompat: !0 });
  } catch (t) {
    if (e.ignoreInvalidStyle)
      return {};
    const r = (
      /** @type {Error} */
      t
    ), i = new ee("Cannot parse `style` attribute", {
      ancestors: e.ancestors,
      cause: r,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    throw i.file = e.filePath || void 0, i.url = Xt + "#cannot-parse-style-attribute", i;
  }
}
function Jt(e, n, t) {
  let r;
  if (!t)
    r = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const i = n.split(".");
    let l = -1, o;
    for (; ++l < i.length; ) {
      const a = Xn(i[l]) ? { type: "Identifier", name: i[l] } : { type: "Literal", value: i[l] };
      o = o ? {
        type: "MemberExpression",
        object: o,
        property: a,
        computed: !!(l && a.type === "Literal"),
        optional: !1
      } : a;
    }
    r = o;
  } else
    r = Xn(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (r.type === "Literal") {
    const i = (
      /** @type {string | number} */
      r.value
    );
    return _n.call(e.components, i) ? e.components[i] : i;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(r);
  je(e);
}
function je(e, n) {
  const t = new ee(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw t.file = e.filePath || void 0, t.url = Xt + "#cannot-handle-mdx-estrees-without-createevaluater", t;
}
function Ui(e) {
  const n = {};
  let t;
  for (t in e)
    _n.call(e, t) && (n[Hi(t)] = e[t]);
  return n;
}
function Hi(e) {
  let n = e.replace(Ii, Vi);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function Vi(e) {
  return "-" + e.toLowerCase();
}
const rn = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, qi = {};
function $i(e, n) {
  const t = qi, r = typeof t.includeImageAlt == "boolean" ? t.includeImageAlt : !0, i = typeof t.includeHtml == "boolean" ? t.includeHtml : !0;
  return Kt(e, r, i);
}
function Kt(e, n, t) {
  if (Yi(e)) {
    if ("value" in e)
      return e.type === "html" && !t ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return lt(e.children, n, t);
  }
  return Array.isArray(e) ? lt(e, n, t) : "";
}
function lt(e, n, t) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = Kt(e[i], n, t);
  return r.join("");
}
function Yi(e) {
  return !!(e && typeof e == "object");
}
const ot = document.createElement("i");
function zn(e) {
  const n = "&" + e + ";";
  ot.innerHTML = n;
  const t = ot.textContent;
  return (
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    t.charCodeAt(t.length - 1) === 59 && e !== "semi" || t === n ? !1 : t
  );
}
function de(e, n, t, r) {
  const i = e.length;
  let l = 0, o;
  if (n < 0 ? n = -n > i ? 0 : i + n : n = n > i ? i : n, t = t > 0 ? t : 0, r.length < 1e4)
    o = Array.from(r), o.unshift(n, t), e.splice(...o);
  else
    for (t && e.splice(n, t); l < r.length; )
      o = r.slice(l, l + 1e4), o.unshift(n, 0), e.splice(...o), l += 1e4, n += 1e4;
}
function ce(e, n) {
  return e.length > 0 ? (de(e, e.length, 0, n), e) : n;
}
const at = {}.hasOwnProperty;
function Wi(e) {
  const n = {};
  let t = -1;
  for (; ++t < e.length; )
    Xi(n, e[t]);
  return n;
}
function Xi(e, n) {
  let t;
  for (t in n) {
    const i = (at.call(e, t) ? e[t] : void 0) || (e[t] = {}), l = n[t];
    let o;
    if (l)
      for (o in l) {
        at.call(i, o) || (i[o] = []);
        const a = l[o];
        Gi(
          // @ts-expect-error Looks like a list.
          i[o],
          Array.isArray(a) ? a : a ? [a] : []
        );
      }
  }
}
function Gi(e, n) {
  let t = -1;
  const r = [];
  for (; ++t < n.length; )
    (n[t].add === "after" ? e : r).push(n[t]);
  de(e, 0, 0, r);
}
function Zt(e, n) {
  const t = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    t < 9 || t === 11 || t > 13 && t < 32 || // Control character (DEL) of C0, and C1 controls.
    t > 126 && t < 160 || // Lone high surrogates and low surrogates.
    t > 55295 && t < 57344 || // Noncharacters.
    t > 64975 && t < 65008 || /* eslint-disable no-bitwise */
    (t & 65535) === 65535 || (t & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    t > 1114111 ? "�" : String.fromCodePoint(t)
  );
}
function Pe(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const me = be(/[A-Za-z]/), ue = be(/[\dA-Za-z]/), Qi = be(/[#-'*+\--9=?A-Z^-~]/);
function bn(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const wn = be(/\d/), Ji = be(/[\dA-Fa-f]/), Ki = be(/[!-/:-@[-`{-~]/);
function v(e) {
  return e !== null && e < -2;
}
function re(e) {
  return e !== null && (e < 0 || e === 32);
}
function M(e) {
  return e === -2 || e === -1 || e === 32;
}
const Zi = be(new RegExp("\\p{P}|\\p{S}", "u")), el = be(/\s/);
function be(e) {
  return n;
  function n(t) {
    return t !== null && t > -1 && e.test(String.fromCharCode(t));
  }
}
function _e(e) {
  const n = [];
  let t = -1, r = 0, i = 0;
  for (; ++t < e.length; ) {
    const l = e.charCodeAt(t);
    let o = "";
    if (l === 37 && ue(e.charCodeAt(t + 1)) && ue(e.charCodeAt(t + 2)))
      i = 2;
    else if (l < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(l)) || (o = String.fromCharCode(l));
    else if (l > 55295 && l < 57344) {
      const a = e.charCodeAt(t + 1);
      l < 56320 && a > 56319 && a < 57344 ? (o = String.fromCharCode(l, a), i = 1) : o = "�";
    } else
      o = String.fromCharCode(l);
    o && (n.push(e.slice(r, t), encodeURIComponent(o)), r = t + i + 1, o = ""), i && (t += i, i = 0);
  }
  return n.join("") + e.slice(r);
}
function q(e, n, t, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let l = 0;
  return o;
  function o(s) {
    return M(s) ? (e.enter(t), a(s)) : n(s);
  }
  function a(s) {
    return M(s) && l++ < i ? (e.consume(s), a) : (e.exit(t), n(s));
  }
}
const nl = {
  tokenize: tl
};
function tl(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, r, i);
  let t;
  return n;
  function r(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), q(e, n, "linePrefix");
  }
  function i(a) {
    return e.enter("paragraph"), l(a);
  }
  function l(a) {
    const s = e.enter("chunkText", {
      contentType: "text",
      previous: t
    });
    return t && (t.next = s), t = s, o(a);
  }
  function o(a) {
    if (a === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(a);
      return;
    }
    return v(a) ? (e.consume(a), e.exit("chunkText"), l) : (e.consume(a), o);
  }
}
const rl = {
  tokenize: il
}, ut = {
  tokenize: ll
};
function il(e) {
  const n = this, t = [];
  let r = 0, i, l, o;
  return a;
  function a(E) {
    if (r < t.length) {
      const N = t[r];
      return n.containerState = N[1], e.attempt(N[0].continuation, s, c)(E);
    }
    return c(E);
  }
  function s(E) {
    if (r++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, i && C();
      const N = n.events.length;
      let O = N, x;
      for (; O--; )
        if (n.events[O][0] === "exit" && n.events[O][1].type === "chunkFlow") {
          x = n.events[O][1].end;
          break;
        }
      w(r);
      let D = N;
      for (; D < n.events.length; )
        n.events[D][1].end = {
          ...x
        }, D++;
      return de(n.events, O + 1, 0, n.events.slice(N)), n.events.length = D, c(E);
    }
    return a(E);
  }
  function c(E) {
    if (r === t.length) {
      if (!i)
        return d(E);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return y(E);
      n.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(ut, f, h)(E);
  }
  function f(E) {
    return i && C(), w(r), d(E);
  }
  function h(E) {
    return n.parser.lazy[n.now().line] = r !== t.length, o = n.now().offset, y(E);
  }
  function d(E) {
    return n.containerState = {}, e.attempt(ut, p, y)(E);
  }
  function p(E) {
    return r++, t.push([n.currentConstruct, n.containerState]), d(E);
  }
  function y(E) {
    if (E === null) {
      i && C(), w(0), e.consume(E);
      return;
    }
    return i = i || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: i,
      contentType: "flow",
      previous: l
    }), k(E);
  }
  function k(E) {
    if (E === null) {
      I(e.exit("chunkFlow"), !0), w(0), e.consume(E);
      return;
    }
    return v(E) ? (e.consume(E), I(e.exit("chunkFlow")), r = 0, n.interrupt = void 0, a) : (e.consume(E), k);
  }
  function I(E, N) {
    const O = n.sliceStream(E);
    if (N && O.push(null), E.previous = l, l && (l.next = E), l = E, i.defineSkip(E.start), i.write(O), n.parser.lazy[E.start.line]) {
      let x = i.events.length;
      for (; x--; )
        if (
          // The token starts before the line ending…
          i.events[x][1].start.offset < o && // …and either is not ended yet…
          (!i.events[x][1].end || // …or ends after it.
          i.events[x][1].end.offset > o)
        )
          return;
      const D = n.events.length;
      let W = D, B, j;
      for (; W--; )
        if (n.events[W][0] === "exit" && n.events[W][1].type === "chunkFlow") {
          if (B) {
            j = n.events[W][1].end;
            break;
          }
          B = !0;
        }
      for (w(r), x = D; x < n.events.length; )
        n.events[x][1].end = {
          ...j
        }, x++;
      de(n.events, W + 1, 0, n.events.slice(D)), n.events.length = x;
    }
  }
  function w(E) {
    let N = t.length;
    for (; N-- > E; ) {
      const O = t[N];
      n.containerState = O[1], O[0].exit.call(n, e);
    }
    t.length = E;
  }
  function C() {
    i.write([null]), l = void 0, i = void 0, n.containerState._closeFlow = void 0;
  }
}
function ll(e, n, t) {
  return q(e, e.attempt(this.parser.constructs.document, n, t), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function st(e) {
  if (e === null || re(e) || el(e))
    return 1;
  if (Zi(e))
    return 2;
}
function Ln(e, n, t) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const l = e[i].resolveAll;
    l && !r.includes(l) && (n = l(n, t), r.push(l));
  }
  return n;
}
const Sn = {
  name: "attention",
  resolveAll: ol,
  tokenize: al
};
function ol(e, n) {
  let t = -1, r, i, l, o, a, s, c, f;
  for (; ++t < e.length; )
    if (e[t][0] === "enter" && e[t][1].type === "attentionSequence" && e[t][1]._close) {
      for (r = t; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        n.sliceSerialize(e[r][1]).charCodeAt(0) === n.sliceSerialize(e[t][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[t][1]._open) && (e[t][1].end.offset - e[t][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[t][1].end.offset - e[t][1].start.offset) % 3))
            continue;
          s = e[r][1].end.offset - e[r][1].start.offset > 1 && e[t][1].end.offset - e[t][1].start.offset > 1 ? 2 : 1;
          const h = {
            ...e[r][1].end
          }, d = {
            ...e[t][1].start
          };
          ct(h, -s), ct(d, s), o = {
            type: s > 1 ? "strongSequence" : "emphasisSequence",
            start: h,
            end: {
              ...e[r][1].end
            }
          }, a = {
            type: s > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[t][1].start
            },
            end: d
          }, l = {
            type: s > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[r][1].end
            },
            end: {
              ...e[t][1].start
            }
          }, i = {
            type: s > 1 ? "strong" : "emphasis",
            start: {
              ...o.start
            },
            end: {
              ...a.end
            }
          }, e[r][1].end = {
            ...o.start
          }, e[t][1].start = {
            ...a.end
          }, c = [], e[r][1].end.offset - e[r][1].start.offset && (c = ce(c, [["enter", e[r][1], n], ["exit", e[r][1], n]])), c = ce(c, [["enter", i, n], ["enter", o, n], ["exit", o, n], ["enter", l, n]]), c = ce(c, Ln(n.parser.constructs.insideSpan.null, e.slice(r + 1, t), n)), c = ce(c, [["exit", l, n], ["enter", a, n], ["exit", a, n], ["exit", i, n]]), e[t][1].end.offset - e[t][1].start.offset ? (f = 2, c = ce(c, [["enter", e[t][1], n], ["exit", e[t][1], n]])) : f = 0, de(e, r - 1, t - r + 3, c), t = r + c.length - f - 2;
          break;
        }
    }
  for (t = -1; ++t < e.length; )
    e[t][1].type === "attentionSequence" && (e[t][1].type = "data");
  return e;
}
function al(e, n) {
  const t = this.parser.constructs.attentionMarkers.null, r = this.previous, i = st(r);
  let l;
  return o;
  function o(s) {
    return l = s, e.enter("attentionSequence"), a(s);
  }
  function a(s) {
    if (s === l)
      return e.consume(s), a;
    const c = e.exit("attentionSequence"), f = st(s), h = !f || f === 2 && i || t.includes(s), d = !i || i === 2 && f || t.includes(r);
    return c._open = !!(l === 42 ? h : h && (i || !d)), c._close = !!(l === 42 ? d : d && (f || !h)), n(s);
  }
}
function ct(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const ul = {
  name: "autolink",
  tokenize: sl
};
function sl(e, n, t) {
  let r = 0;
  return i;
  function i(p) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), l;
  }
  function l(p) {
    return me(p) ? (e.consume(p), o) : p === 64 ? t(p) : c(p);
  }
  function o(p) {
    return p === 43 || p === 45 || p === 46 || ue(p) ? (r = 1, a(p)) : c(p);
  }
  function a(p) {
    return p === 58 ? (e.consume(p), r = 0, s) : (p === 43 || p === 45 || p === 46 || ue(p)) && r++ < 32 ? (e.consume(p), a) : (r = 0, c(p));
  }
  function s(p) {
    return p === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.exit("autolink"), n) : p === null || p === 32 || p === 60 || bn(p) ? t(p) : (e.consume(p), s);
  }
  function c(p) {
    return p === 64 ? (e.consume(p), f) : Qi(p) ? (e.consume(p), c) : t(p);
  }
  function f(p) {
    return ue(p) ? h(p) : t(p);
  }
  function h(p) {
    return p === 46 ? (e.consume(p), r = 0, f) : p === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.exit("autolink"), n) : d(p);
  }
  function d(p) {
    if ((p === 45 || ue(p)) && r++ < 63) {
      const y = p === 45 ? d : h;
      return e.consume(p), y;
    }
    return t(p);
  }
}
const Ke = {
  partial: !0,
  tokenize: cl
};
function cl(e, n, t) {
  return r;
  function r(l) {
    return M(l) ? q(e, i, "linePrefix")(l) : i(l);
  }
  function i(l) {
    return l === null || v(l) ? n(l) : t(l);
  }
}
const er = {
  continuation: {
    tokenize: pl
  },
  exit: hl,
  name: "blockQuote",
  tokenize: fl
};
function fl(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    if (o === 62) {
      const a = r.containerState;
      return a.open || (e.enter("blockQuote", {
        _container: !0
      }), a.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(o), e.exit("blockQuoteMarker"), l;
    }
    return t(o);
  }
  function l(o) {
    return M(o) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(o), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(o));
  }
}
function pl(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return M(o) ? q(e, l, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(o) : l(o);
  }
  function l(o) {
    return e.attempt(er, n, t)(o);
  }
}
function hl(e) {
  e.exit("blockQuote");
}
const nr = {
  name: "characterEscape",
  tokenize: ml
};
function ml(e, n, t) {
  return r;
  function r(l) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(l), e.exit("escapeMarker"), i;
  }
  function i(l) {
    return Ki(l) ? (e.enter("characterEscapeValue"), e.consume(l), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : t(l);
  }
}
const tr = {
  name: "characterReference",
  tokenize: dl
};
function dl(e, n, t) {
  const r = this;
  let i = 0, l, o;
  return a;
  function a(h) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(h), e.exit("characterReferenceMarker"), s;
  }
  function s(h) {
    return h === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(h), e.exit("characterReferenceMarkerNumeric"), c) : (e.enter("characterReferenceValue"), l = 31, o = ue, f(h));
  }
  function c(h) {
    return h === 88 || h === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(h), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), l = 6, o = Ji, f) : (e.enter("characterReferenceValue"), l = 7, o = wn, f(h));
  }
  function f(h) {
    if (h === 59 && i) {
      const d = e.exit("characterReferenceValue");
      return o === ue && !zn(r.sliceSerialize(d)) ? t(h) : (e.enter("characterReferenceMarker"), e.consume(h), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return o(h) && i++ < l ? (e.consume(h), f) : t(h);
  }
}
const ft = {
  partial: !0,
  tokenize: yl
}, pt = {
  concrete: !0,
  name: "codeFenced",
  tokenize: gl
};
function gl(e, n, t) {
  const r = this, i = {
    partial: !0,
    tokenize: O
  };
  let l = 0, o = 0, a;
  return s;
  function s(x) {
    return c(x);
  }
  function c(x) {
    const D = r.events[r.events.length - 1];
    return l = D && D[1].type === "linePrefix" ? D[2].sliceSerialize(D[1], !0).length : 0, a = x, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), f(x);
  }
  function f(x) {
    return x === a ? (o++, e.consume(x), f) : o < 3 ? t(x) : (e.exit("codeFencedFenceSequence"), M(x) ? q(e, h, "whitespace")(x) : h(x));
  }
  function h(x) {
    return x === null || v(x) ? (e.exit("codeFencedFence"), r.interrupt ? n(x) : e.check(ft, k, N)(x)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), d(x));
  }
  function d(x) {
    return x === null || v(x) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), h(x)) : M(x) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), q(e, p, "whitespace")(x)) : x === 96 && x === a ? t(x) : (e.consume(x), d);
  }
  function p(x) {
    return x === null || v(x) ? h(x) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), y(x));
  }
  function y(x) {
    return x === null || v(x) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), h(x)) : x === 96 && x === a ? t(x) : (e.consume(x), y);
  }
  function k(x) {
    return e.attempt(i, N, I)(x);
  }
  function I(x) {
    return e.enter("lineEnding"), e.consume(x), e.exit("lineEnding"), w;
  }
  function w(x) {
    return l > 0 && M(x) ? q(e, C, "linePrefix", l + 1)(x) : C(x);
  }
  function C(x) {
    return x === null || v(x) ? e.check(ft, k, N)(x) : (e.enter("codeFlowValue"), E(x));
  }
  function E(x) {
    return x === null || v(x) ? (e.exit("codeFlowValue"), C(x)) : (e.consume(x), E);
  }
  function N(x) {
    return e.exit("codeFenced"), n(x);
  }
  function O(x, D, W) {
    let B = 0;
    return j;
    function j(z) {
      return x.enter("lineEnding"), x.consume(z), x.exit("lineEnding"), A;
    }
    function A(z) {
      return x.enter("codeFencedFence"), M(z) ? q(x, T, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(z) : T(z);
    }
    function T(z) {
      return z === a ? (x.enter("codeFencedFenceSequence"), H(z)) : W(z);
    }
    function H(z) {
      return z === a ? (B++, x.consume(z), H) : B >= o ? (x.exit("codeFencedFenceSequence"), M(z) ? q(x, Y, "whitespace")(z) : Y(z)) : W(z);
    }
    function Y(z) {
      return z === null || v(z) ? (x.exit("codeFencedFence"), D(z)) : W(z);
    }
  }
}
function yl(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return o === null ? t(o) : (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), l);
  }
  function l(o) {
    return r.parser.lazy[r.now().line] ? t(o) : n(o);
  }
}
const ln = {
  name: "codeIndented",
  tokenize: kl
}, xl = {
  partial: !0,
  tokenize: bl
};
function kl(e, n, t) {
  const r = this;
  return i;
  function i(c) {
    return e.enter("codeIndented"), q(e, l, "linePrefix", 5)(c);
  }
  function l(c) {
    const f = r.events[r.events.length - 1];
    return f && f[1].type === "linePrefix" && f[2].sliceSerialize(f[1], !0).length >= 4 ? o(c) : t(c);
  }
  function o(c) {
    return c === null ? s(c) : v(c) ? e.attempt(xl, o, s)(c) : (e.enter("codeFlowValue"), a(c));
  }
  function a(c) {
    return c === null || v(c) ? (e.exit("codeFlowValue"), o(c)) : (e.consume(c), a);
  }
  function s(c) {
    return e.exit("codeIndented"), n(c);
  }
}
function bl(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return r.parser.lazy[r.now().line] ? t(o) : v(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), i) : q(e, l, "linePrefix", 5)(o);
  }
  function l(o) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? n(o) : v(o) ? i(o) : t(o);
  }
}
const wl = {
  name: "codeText",
  previous: El,
  resolve: Sl,
  tokenize: Cl
};
function Sl(e) {
  let n = e.length - 4, t = 3, r, i;
  if ((e[t][1].type === "lineEnding" || e[t][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (r = t; ++r < n; )
      if (e[r][1].type === "codeTextData") {
        e[t][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", t += 2, n -= 2;
        break;
      }
  }
  for (r = t - 1, n++; ++r <= n; )
    i === void 0 ? r !== n && e[r][1].type !== "lineEnding" && (i = r) : (r === n || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), n -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function El(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function Cl(e, n, t) {
  let r = 0, i, l;
  return o;
  function o(h) {
    return e.enter("codeText"), e.enter("codeTextSequence"), a(h);
  }
  function a(h) {
    return h === 96 ? (e.consume(h), r++, a) : (e.exit("codeTextSequence"), s(h));
  }
  function s(h) {
    return h === null ? t(h) : h === 32 ? (e.enter("space"), e.consume(h), e.exit("space"), s) : h === 96 ? (l = e.enter("codeTextSequence"), i = 0, f(h)) : v(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), s) : (e.enter("codeTextData"), c(h));
  }
  function c(h) {
    return h === null || h === 32 || h === 96 || v(h) ? (e.exit("codeTextData"), s(h)) : (e.consume(h), c);
  }
  function f(h) {
    return h === 96 ? (e.consume(h), i++, f) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), n(h)) : (l.type = "codeTextData", c(h));
  }
}
class Il {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, t) {
    const r = t ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(n, r) : n > this.left.length ? this.right.slice(this.right.length - r + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - r + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, t, r) {
    const i = t || 0;
    this.setCursor(Math.trunc(n));
    const l = this.right.splice(this.right.length - i, Number.POSITIVE_INFINITY);
    return r && Ne(this.left, r), l.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), Ne(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), Ne(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const t = this.left.splice(n, Number.POSITIVE_INFINITY);
        Ne(this.right, t.reverse());
      } else {
        const t = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        Ne(this.left, t.reverse());
      }
  }
}
function Ne(e, n) {
  let t = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; t < n.length; )
      e.push(...n.slice(t, t + 1e4)), t += 1e4;
}
function rr(e) {
  const n = {};
  let t = -1, r, i, l, o, a, s, c;
  const f = new Il(e);
  for (; ++t < f.length; ) {
    for (; t in n; )
      t = n[t];
    if (r = f.get(t), t && r[1].type === "chunkFlow" && f.get(t - 1)[1].type === "listItemPrefix" && (s = r[1]._tokenizer.events, l = 0, l < s.length && s[l][1].type === "lineEndingBlank" && (l += 2), l < s.length && s[l][1].type === "content"))
      for (; ++l < s.length && s[l][1].type !== "content"; )
        s[l][1].type === "chunkText" && (s[l][1]._isInFirstContentOfListItem = !0, l++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(n, Tl(f, t)), t = n[t], c = !0);
    else if (r[1]._container) {
      for (l = t, i = void 0; l--; )
        if (o = f.get(l), o[1].type === "lineEnding" || o[1].type === "lineEndingBlank")
          o[0] === "enter" && (i && (f.get(i)[1].type = "lineEndingBlank"), o[1].type = "lineEnding", i = l);
        else if (!(o[1].type === "linePrefix" || o[1].type === "listItemIndent")) break;
      i && (r[1].end = {
        ...f.get(i)[1].start
      }, a = f.slice(i, t), a.unshift(r), f.splice(i, t - i + 1, a));
    }
  }
  return de(e, 0, Number.POSITIVE_INFINITY, f.slice(0)), !c;
}
function Tl(e, n) {
  const t = e.get(n)[1], r = e.get(n)[2];
  let i = n - 1;
  const l = [];
  let o = t._tokenizer;
  o || (o = r.parser[t.contentType](t.start), t._contentTypeTextTrailing && (o._contentTypeTextTrailing = !0));
  const a = o.events, s = [], c = {};
  let f, h, d = -1, p = t, y = 0, k = 0;
  const I = [k];
  for (; p; ) {
    for (; e.get(++i)[1] !== p; )
      ;
    l.push(i), p._tokenizer || (f = r.sliceStream(p), p.next || f.push(null), h && o.defineSkip(p.start), p._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(f), p._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), h = p, p = p.next;
  }
  for (p = t; ++d < a.length; )
    // Find a void token that includes a break.
    a[d][0] === "exit" && a[d - 1][0] === "enter" && a[d][1].type === a[d - 1][1].type && a[d][1].start.line !== a[d][1].end.line && (k = d + 1, I.push(k), p._tokenizer = void 0, p.previous = void 0, p = p.next);
  for (o.events = [], p ? (p._tokenizer = void 0, p.previous = void 0) : I.pop(), d = I.length; d--; ) {
    const w = a.slice(I[d], I[d + 1]), C = l.pop();
    s.push([C, C + w.length - 1]), e.splice(C, 2, w);
  }
  for (s.reverse(), d = -1; ++d < s.length; )
    c[y + s[d][0]] = y + s[d][1], y += s[d][1] - s[d][0] - 1;
  return c;
}
const Al = {
  resolve: vl,
  tokenize: _l
}, Pl = {
  partial: !0,
  tokenize: Rl
};
function vl(e) {
  return rr(e), e;
}
function _l(e, n) {
  let t;
  return r;
  function r(a) {
    return e.enter("content"), t = e.enter("chunkContent", {
      contentType: "content"
    }), i(a);
  }
  function i(a) {
    return a === null ? l(a) : v(a) ? e.check(Pl, o, l)(a) : (e.consume(a), i);
  }
  function l(a) {
    return e.exit("chunkContent"), e.exit("content"), n(a);
  }
  function o(a) {
    return e.consume(a), e.exit("chunkContent"), t.next = e.enter("chunkContent", {
      contentType: "content",
      previous: t
    }), t = t.next, i;
  }
}
function Rl(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), q(e, l, "linePrefix");
  }
  function l(o) {
    if (o === null || v(o))
      return t(o);
    const a = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? n(o) : e.interrupt(r.parser.constructs.flow, t, n)(o);
  }
}
function ir(e, n, t, r, i, l, o, a, s) {
  const c = s || Number.POSITIVE_INFINITY;
  let f = 0;
  return h;
  function h(w) {
    return w === 60 ? (e.enter(r), e.enter(i), e.enter(l), e.consume(w), e.exit(l), d) : w === null || w === 32 || w === 41 || bn(w) ? t(w) : (e.enter(r), e.enter(o), e.enter(a), e.enter("chunkString", {
      contentType: "string"
    }), k(w));
  }
  function d(w) {
    return w === 62 ? (e.enter(l), e.consume(w), e.exit(l), e.exit(i), e.exit(r), n) : (e.enter(a), e.enter("chunkString", {
      contentType: "string"
    }), p(w));
  }
  function p(w) {
    return w === 62 ? (e.exit("chunkString"), e.exit(a), d(w)) : w === null || w === 60 || v(w) ? t(w) : (e.consume(w), w === 92 ? y : p);
  }
  function y(w) {
    return w === 60 || w === 62 || w === 92 ? (e.consume(w), p) : p(w);
  }
  function k(w) {
    return !f && (w === null || w === 41 || re(w)) ? (e.exit("chunkString"), e.exit(a), e.exit(o), e.exit(r), n(w)) : f < c && w === 40 ? (e.consume(w), f++, k) : w === 41 ? (e.consume(w), f--, k) : w === null || w === 32 || w === 40 || bn(w) ? t(w) : (e.consume(w), w === 92 ? I : k);
  }
  function I(w) {
    return w === 40 || w === 41 || w === 92 ? (e.consume(w), k) : k(w);
  }
}
function lr(e, n, t, r, i, l) {
  const o = this;
  let a = 0, s;
  return c;
  function c(p) {
    return e.enter(r), e.enter(i), e.consume(p), e.exit(i), e.enter(l), f;
  }
  function f(p) {
    return a > 999 || p === null || p === 91 || p === 93 && !s || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    p === 94 && !a && "_hiddenFootnoteSupport" in o.parser.constructs ? t(p) : p === 93 ? (e.exit(l), e.enter(i), e.consume(p), e.exit(i), e.exit(r), n) : v(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), f) : (e.enter("chunkString", {
      contentType: "string"
    }), h(p));
  }
  function h(p) {
    return p === null || p === 91 || p === 93 || v(p) || a++ > 999 ? (e.exit("chunkString"), f(p)) : (e.consume(p), s || (s = !M(p)), p === 92 ? d : h);
  }
  function d(p) {
    return p === 91 || p === 92 || p === 93 ? (e.consume(p), a++, h) : h(p);
  }
}
function or(e, n, t, r, i, l) {
  let o;
  return a;
  function a(d) {
    return d === 34 || d === 39 || d === 40 ? (e.enter(r), e.enter(i), e.consume(d), e.exit(i), o = d === 40 ? 41 : d, s) : t(d);
  }
  function s(d) {
    return d === o ? (e.enter(i), e.consume(d), e.exit(i), e.exit(r), n) : (e.enter(l), c(d));
  }
  function c(d) {
    return d === o ? (e.exit(l), s(o)) : d === null ? t(d) : v(d) ? (e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), q(e, c, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), f(d));
  }
  function f(d) {
    return d === o || d === null || v(d) ? (e.exit("chunkString"), c(d)) : (e.consume(d), d === 92 ? h : f);
  }
  function h(d) {
    return d === o || d === 92 ? (e.consume(d), f) : f(d);
  }
}
function Me(e, n) {
  let t;
  return r;
  function r(i) {
    return v(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), t = !0, r) : M(i) ? q(e, r, t ? "linePrefix" : "lineSuffix")(i) : n(i);
  }
}
const Ol = {
  name: "definition",
  tokenize: Ll
}, zl = {
  partial: !0,
  tokenize: Nl
};
function Ll(e, n, t) {
  const r = this;
  let i;
  return l;
  function l(p) {
    return e.enter("definition"), o(p);
  }
  function o(p) {
    return lr.call(
      r,
      e,
      a,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(p);
  }
  function a(p) {
    return i = Pe(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), p === 58 ? (e.enter("definitionMarker"), e.consume(p), e.exit("definitionMarker"), s) : t(p);
  }
  function s(p) {
    return re(p) ? Me(e, c)(p) : c(p);
  }
  function c(p) {
    return ir(
      e,
      f,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(p);
  }
  function f(p) {
    return e.attempt(zl, h, h)(p);
  }
  function h(p) {
    return M(p) ? q(e, d, "whitespace")(p) : d(p);
  }
  function d(p) {
    return p === null || v(p) ? (e.exit("definition"), r.parser.defined.push(i), n(p)) : t(p);
  }
}
function Nl(e, n, t) {
  return r;
  function r(a) {
    return re(a) ? Me(e, i)(a) : t(a);
  }
  function i(a) {
    return or(e, l, t, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(a);
  }
  function l(a) {
    return M(a) ? q(e, o, "whitespace")(a) : o(a);
  }
  function o(a) {
    return a === null || v(a) ? n(a) : t(a);
  }
}
const Dl = {
  name: "hardBreakEscape",
  tokenize: Fl
};
function Fl(e, n, t) {
  return r;
  function r(l) {
    return e.enter("hardBreakEscape"), e.consume(l), i;
  }
  function i(l) {
    return v(l) ? (e.exit("hardBreakEscape"), n(l)) : t(l);
  }
}
const Ml = {
  name: "headingAtx",
  resolve: Bl,
  tokenize: jl
};
function Bl(e, n) {
  let t = e.length - 2, r = 3, i, l;
  return e[r][1].type === "whitespace" && (r += 2), t - 2 > r && e[t][1].type === "whitespace" && (t -= 2), e[t][1].type === "atxHeadingSequence" && (r === t - 1 || t - 4 > r && e[t - 2][1].type === "whitespace") && (t -= r + 1 === t ? 2 : 4), t > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[t][1].end
  }, l = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[t][1].end,
    contentType: "text"
  }, de(e, r, t - r + 1, [["enter", i, n], ["enter", l, n], ["exit", l, n], ["exit", i, n]])), e;
}
function jl(e, n, t) {
  let r = 0;
  return i;
  function i(f) {
    return e.enter("atxHeading"), l(f);
  }
  function l(f) {
    return e.enter("atxHeadingSequence"), o(f);
  }
  function o(f) {
    return f === 35 && r++ < 6 ? (e.consume(f), o) : f === null || re(f) ? (e.exit("atxHeadingSequence"), a(f)) : t(f);
  }
  function a(f) {
    return f === 35 ? (e.enter("atxHeadingSequence"), s(f)) : f === null || v(f) ? (e.exit("atxHeading"), n(f)) : M(f) ? q(e, a, "whitespace")(f) : (e.enter("atxHeadingText"), c(f));
  }
  function s(f) {
    return f === 35 ? (e.consume(f), s) : (e.exit("atxHeadingSequence"), a(f));
  }
  function c(f) {
    return f === null || f === 35 || re(f) ? (e.exit("atxHeadingText"), a(f)) : (e.consume(f), c);
  }
}
const Ul = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], ht = ["pre", "script", "style", "textarea"], Hl = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: $l,
  tokenize: Yl
}, Vl = {
  partial: !0,
  tokenize: Xl
}, ql = {
  partial: !0,
  tokenize: Wl
};
function $l(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function Yl(e, n, t) {
  const r = this;
  let i, l, o, a, s;
  return c;
  function c(m) {
    return f(m);
  }
  function f(m) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(m), h;
  }
  function h(m) {
    return m === 33 ? (e.consume(m), d) : m === 47 ? (e.consume(m), l = !0, k) : m === 63 ? (e.consume(m), i = 3, r.interrupt ? n : u) : me(m) ? (e.consume(m), o = String.fromCharCode(m), I) : t(m);
  }
  function d(m) {
    return m === 45 ? (e.consume(m), i = 2, p) : m === 91 ? (e.consume(m), i = 5, a = 0, y) : me(m) ? (e.consume(m), i = 4, r.interrupt ? n : u) : t(m);
  }
  function p(m) {
    return m === 45 ? (e.consume(m), r.interrupt ? n : u) : t(m);
  }
  function y(m) {
    const Q = "CDATA[";
    return m === Q.charCodeAt(a++) ? (e.consume(m), a === Q.length ? r.interrupt ? n : T : y) : t(m);
  }
  function k(m) {
    return me(m) ? (e.consume(m), o = String.fromCharCode(m), I) : t(m);
  }
  function I(m) {
    if (m === null || m === 47 || m === 62 || re(m)) {
      const Q = m === 47, Z = o.toLowerCase();
      return !Q && !l && ht.includes(Z) ? (i = 1, r.interrupt ? n(m) : T(m)) : Ul.includes(o.toLowerCase()) ? (i = 6, Q ? (e.consume(m), w) : r.interrupt ? n(m) : T(m)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? t(m) : l ? C(m) : E(m));
    }
    return m === 45 || ue(m) ? (e.consume(m), o += String.fromCharCode(m), I) : t(m);
  }
  function w(m) {
    return m === 62 ? (e.consume(m), r.interrupt ? n : T) : t(m);
  }
  function C(m) {
    return M(m) ? (e.consume(m), C) : j(m);
  }
  function E(m) {
    return m === 47 ? (e.consume(m), j) : m === 58 || m === 95 || me(m) ? (e.consume(m), N) : M(m) ? (e.consume(m), E) : j(m);
  }
  function N(m) {
    return m === 45 || m === 46 || m === 58 || m === 95 || ue(m) ? (e.consume(m), N) : O(m);
  }
  function O(m) {
    return m === 61 ? (e.consume(m), x) : M(m) ? (e.consume(m), O) : E(m);
  }
  function x(m) {
    return m === null || m === 60 || m === 61 || m === 62 || m === 96 ? t(m) : m === 34 || m === 39 ? (e.consume(m), s = m, D) : M(m) ? (e.consume(m), x) : W(m);
  }
  function D(m) {
    return m === s ? (e.consume(m), s = null, B) : m === null || v(m) ? t(m) : (e.consume(m), D);
  }
  function W(m) {
    return m === null || m === 34 || m === 39 || m === 47 || m === 60 || m === 61 || m === 62 || m === 96 || re(m) ? O(m) : (e.consume(m), W);
  }
  function B(m) {
    return m === 47 || m === 62 || M(m) ? E(m) : t(m);
  }
  function j(m) {
    return m === 62 ? (e.consume(m), A) : t(m);
  }
  function A(m) {
    return m === null || v(m) ? T(m) : M(m) ? (e.consume(m), A) : t(m);
  }
  function T(m) {
    return m === 45 && i === 2 ? (e.consume(m), K) : m === 60 && i === 1 ? (e.consume(m), G) : m === 62 && i === 4 ? (e.consume(m), P) : m === 63 && i === 3 ? (e.consume(m), u) : m === 93 && i === 5 ? (e.consume(m), se) : v(m) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(Vl, F, H)(m)) : m === null || v(m) ? (e.exit("htmlFlowData"), H(m)) : (e.consume(m), T);
  }
  function H(m) {
    return e.check(ql, Y, F)(m);
  }
  function Y(m) {
    return e.enter("lineEnding"), e.consume(m), e.exit("lineEnding"), z;
  }
  function z(m) {
    return m === null || v(m) ? H(m) : (e.enter("htmlFlowData"), T(m));
  }
  function K(m) {
    return m === 45 ? (e.consume(m), u) : T(m);
  }
  function G(m) {
    return m === 47 ? (e.consume(m), o = "", ne) : T(m);
  }
  function ne(m) {
    if (m === 62) {
      const Q = o.toLowerCase();
      return ht.includes(Q) ? (e.consume(m), P) : T(m);
    }
    return me(m) && o.length < 8 ? (e.consume(m), o += String.fromCharCode(m), ne) : T(m);
  }
  function se(m) {
    return m === 93 ? (e.consume(m), u) : T(m);
  }
  function u(m) {
    return m === 62 ? (e.consume(m), P) : m === 45 && i === 2 ? (e.consume(m), u) : T(m);
  }
  function P(m) {
    return m === null || v(m) ? (e.exit("htmlFlowData"), F(m)) : (e.consume(m), P);
  }
  function F(m) {
    return e.exit("htmlFlow"), n(m);
  }
}
function Wl(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return v(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), l) : t(o);
  }
  function l(o) {
    return r.parser.lazy[r.now().line] ? t(o) : n(o);
  }
}
function Xl(e, n, t) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(Ke, n, t);
  }
}
const Gl = {
  name: "htmlText",
  tokenize: Ql
};
function Ql(e, n, t) {
  const r = this;
  let i, l, o;
  return a;
  function a(u) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(u), s;
  }
  function s(u) {
    return u === 33 ? (e.consume(u), c) : u === 47 ? (e.consume(u), O) : u === 63 ? (e.consume(u), E) : me(u) ? (e.consume(u), W) : t(u);
  }
  function c(u) {
    return u === 45 ? (e.consume(u), f) : u === 91 ? (e.consume(u), l = 0, y) : me(u) ? (e.consume(u), C) : t(u);
  }
  function f(u) {
    return u === 45 ? (e.consume(u), p) : t(u);
  }
  function h(u) {
    return u === null ? t(u) : u === 45 ? (e.consume(u), d) : v(u) ? (o = h, G(u)) : (e.consume(u), h);
  }
  function d(u) {
    return u === 45 ? (e.consume(u), p) : h(u);
  }
  function p(u) {
    return u === 62 ? K(u) : u === 45 ? d(u) : h(u);
  }
  function y(u) {
    const P = "CDATA[";
    return u === P.charCodeAt(l++) ? (e.consume(u), l === P.length ? k : y) : t(u);
  }
  function k(u) {
    return u === null ? t(u) : u === 93 ? (e.consume(u), I) : v(u) ? (o = k, G(u)) : (e.consume(u), k);
  }
  function I(u) {
    return u === 93 ? (e.consume(u), w) : k(u);
  }
  function w(u) {
    return u === 62 ? K(u) : u === 93 ? (e.consume(u), w) : k(u);
  }
  function C(u) {
    return u === null || u === 62 ? K(u) : v(u) ? (o = C, G(u)) : (e.consume(u), C);
  }
  function E(u) {
    return u === null ? t(u) : u === 63 ? (e.consume(u), N) : v(u) ? (o = E, G(u)) : (e.consume(u), E);
  }
  function N(u) {
    return u === 62 ? K(u) : E(u);
  }
  function O(u) {
    return me(u) ? (e.consume(u), x) : t(u);
  }
  function x(u) {
    return u === 45 || ue(u) ? (e.consume(u), x) : D(u);
  }
  function D(u) {
    return v(u) ? (o = D, G(u)) : M(u) ? (e.consume(u), D) : K(u);
  }
  function W(u) {
    return u === 45 || ue(u) ? (e.consume(u), W) : u === 47 || u === 62 || re(u) ? B(u) : t(u);
  }
  function B(u) {
    return u === 47 ? (e.consume(u), K) : u === 58 || u === 95 || me(u) ? (e.consume(u), j) : v(u) ? (o = B, G(u)) : M(u) ? (e.consume(u), B) : K(u);
  }
  function j(u) {
    return u === 45 || u === 46 || u === 58 || u === 95 || ue(u) ? (e.consume(u), j) : A(u);
  }
  function A(u) {
    return u === 61 ? (e.consume(u), T) : v(u) ? (o = A, G(u)) : M(u) ? (e.consume(u), A) : B(u);
  }
  function T(u) {
    return u === null || u === 60 || u === 61 || u === 62 || u === 96 ? t(u) : u === 34 || u === 39 ? (e.consume(u), i = u, H) : v(u) ? (o = T, G(u)) : M(u) ? (e.consume(u), T) : (e.consume(u), Y);
  }
  function H(u) {
    return u === i ? (e.consume(u), i = void 0, z) : u === null ? t(u) : v(u) ? (o = H, G(u)) : (e.consume(u), H);
  }
  function Y(u) {
    return u === null || u === 34 || u === 39 || u === 60 || u === 61 || u === 96 ? t(u) : u === 47 || u === 62 || re(u) ? B(u) : (e.consume(u), Y);
  }
  function z(u) {
    return u === 47 || u === 62 || re(u) ? B(u) : t(u);
  }
  function K(u) {
    return u === 62 ? (e.consume(u), e.exit("htmlTextData"), e.exit("htmlText"), n) : t(u);
  }
  function G(u) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(u), e.exit("lineEnding"), ne;
  }
  function ne(u) {
    return M(u) ? q(e, se, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(u) : se(u);
  }
  function se(u) {
    return e.enter("htmlTextData"), o(u);
  }
}
const Nn = {
  name: "labelEnd",
  resolveAll: eo,
  resolveTo: no,
  tokenize: to
}, Jl = {
  tokenize: ro
}, Kl = {
  tokenize: io
}, Zl = {
  tokenize: lo
};
function eo(e) {
  let n = -1;
  const t = [];
  for (; ++n < e.length; ) {
    const r = e[n][1];
    if (t.push(e[n]), r.type === "labelImage" || r.type === "labelLink" || r.type === "labelEnd") {
      const i = r.type === "labelImage" ? 4 : 2;
      r.type = "data", n += i;
    }
  }
  return e.length !== t.length && de(e, 0, e.length, t), e;
}
function no(e, n) {
  let t = e.length, r = 0, i, l, o, a;
  for (; t--; )
    if (i = e[t][1], l) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[t][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (o) {
      if (e[t][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (l = t, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else i.type === "labelEnd" && (o = t);
  const s = {
    type: e[l][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[l][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, c = {
    type: "label",
    start: {
      ...e[l][1].start
    },
    end: {
      ...e[o][1].end
    }
  }, f = {
    type: "labelText",
    start: {
      ...e[l + r + 2][1].end
    },
    end: {
      ...e[o - 2][1].start
    }
  };
  return a = [["enter", s, n], ["enter", c, n]], a = ce(a, e.slice(l + 1, l + r + 3)), a = ce(a, [["enter", f, n]]), a = ce(a, Ln(n.parser.constructs.insideSpan.null, e.slice(l + r + 4, o - 3), n)), a = ce(a, [["exit", f, n], e[o - 2], e[o - 1], ["exit", c, n]]), a = ce(a, e.slice(o + 1)), a = ce(a, [["exit", s, n]]), de(e, l, e.length, a), e;
}
function to(e, n, t) {
  const r = this;
  let i = r.events.length, l, o;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      l = r.events[i][1];
      break;
    }
  return a;
  function a(d) {
    return l ? l._inactive ? h(d) : (o = r.parser.defined.includes(Pe(r.sliceSerialize({
      start: l.end,
      end: r.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(d), e.exit("labelMarker"), e.exit("labelEnd"), s) : t(d);
  }
  function s(d) {
    return d === 40 ? e.attempt(Jl, f, o ? f : h)(d) : d === 91 ? e.attempt(Kl, f, o ? c : h)(d) : o ? f(d) : h(d);
  }
  function c(d) {
    return e.attempt(Zl, f, h)(d);
  }
  function f(d) {
    return n(d);
  }
  function h(d) {
    return l._balanced = !0, t(d);
  }
}
function ro(e, n, t) {
  return r;
  function r(h) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(h), e.exit("resourceMarker"), i;
  }
  function i(h) {
    return re(h) ? Me(e, l)(h) : l(h);
  }
  function l(h) {
    return h === 41 ? f(h) : ir(e, o, a, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(h);
  }
  function o(h) {
    return re(h) ? Me(e, s)(h) : f(h);
  }
  function a(h) {
    return t(h);
  }
  function s(h) {
    return h === 34 || h === 39 || h === 40 ? or(e, c, t, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(h) : f(h);
  }
  function c(h) {
    return re(h) ? Me(e, f)(h) : f(h);
  }
  function f(h) {
    return h === 41 ? (e.enter("resourceMarker"), e.consume(h), e.exit("resourceMarker"), e.exit("resource"), n) : t(h);
  }
}
function io(e, n, t) {
  const r = this;
  return i;
  function i(a) {
    return lr.call(r, e, l, o, "reference", "referenceMarker", "referenceString")(a);
  }
  function l(a) {
    return r.parser.defined.includes(Pe(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? n(a) : t(a);
  }
  function o(a) {
    return t(a);
  }
}
function lo(e, n, t) {
  return r;
  function r(l) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(l), e.exit("referenceMarker"), i;
  }
  function i(l) {
    return l === 93 ? (e.enter("referenceMarker"), e.consume(l), e.exit("referenceMarker"), e.exit("reference"), n) : t(l);
  }
}
const oo = {
  name: "labelStartImage",
  resolveAll: Nn.resolveAll,
  tokenize: ao
};
function ao(e, n, t) {
  const r = this;
  return i;
  function i(a) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(a), e.exit("labelImageMarker"), l;
  }
  function l(a) {
    return a === 91 ? (e.enter("labelMarker"), e.consume(a), e.exit("labelMarker"), e.exit("labelImage"), o) : t(a);
  }
  function o(a) {
    return a === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? t(a) : n(a);
  }
}
const uo = {
  name: "labelStartLink",
  resolveAll: Nn.resolveAll,
  tokenize: so
};
function so(e, n, t) {
  const r = this;
  return i;
  function i(o) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelLink"), l;
  }
  function l(o) {
    return o === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? t(o) : n(o);
  }
}
const on = {
  name: "lineEnding",
  tokenize: co
};
function co(e, n) {
  return t;
  function t(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), q(e, n, "linePrefix");
  }
}
const Ye = {
  name: "thematicBreak",
  tokenize: fo
};
function fo(e, n, t) {
  let r = 0, i;
  return l;
  function l(c) {
    return e.enter("thematicBreak"), o(c);
  }
  function o(c) {
    return i = c, a(c);
  }
  function a(c) {
    return c === i ? (e.enter("thematicBreakSequence"), s(c)) : r >= 3 && (c === null || v(c)) ? (e.exit("thematicBreak"), n(c)) : t(c);
  }
  function s(c) {
    return c === i ? (e.consume(c), r++, s) : (e.exit("thematicBreakSequence"), M(c) ? q(e, a, "whitespace")(c) : a(c));
  }
}
const te = {
  continuation: {
    tokenize: go
  },
  exit: xo,
  name: "list",
  tokenize: mo
}, po = {
  partial: !0,
  tokenize: ko
}, ho = {
  partial: !0,
  tokenize: yo
};
function mo(e, n, t) {
  const r = this, i = r.events[r.events.length - 1];
  let l = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, o = 0;
  return a;
  function a(p) {
    const y = r.containerState.type || (p === 42 || p === 43 || p === 45 ? "listUnordered" : "listOrdered");
    if (y === "listUnordered" ? !r.containerState.marker || p === r.containerState.marker : wn(p)) {
      if (r.containerState.type || (r.containerState.type = y, e.enter(y, {
        _container: !0
      })), y === "listUnordered")
        return e.enter("listItemPrefix"), p === 42 || p === 45 ? e.check(Ye, t, c)(p) : c(p);
      if (!r.interrupt || p === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), s(p);
    }
    return t(p);
  }
  function s(p) {
    return wn(p) && ++o < 10 ? (e.consume(p), s) : (!r.interrupt || o < 2) && (r.containerState.marker ? p === r.containerState.marker : p === 41 || p === 46) ? (e.exit("listItemValue"), c(p)) : t(p);
  }
  function c(p) {
    return e.enter("listItemMarker"), e.consume(p), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || p, e.check(
      Ke,
      // Can’t be empty when interrupting.
      r.interrupt ? t : f,
      e.attempt(po, d, h)
    );
  }
  function f(p) {
    return r.containerState.initialBlankLine = !0, l++, d(p);
  }
  function h(p) {
    return M(p) ? (e.enter("listItemPrefixWhitespace"), e.consume(p), e.exit("listItemPrefixWhitespace"), d) : t(p);
  }
  function d(p) {
    return r.containerState.size = l + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(p);
  }
}
function go(e, n, t) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(Ke, i, l);
  function i(a) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, q(e, n, "listItemIndent", r.containerState.size + 1)(a);
  }
  function l(a) {
    return r.containerState.furtherBlankLines || !M(a) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, o(a)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(ho, n, o)(a));
  }
  function o(a) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, q(e, e.attempt(te, n, t), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(a);
  }
}
function yo(e, n, t) {
  const r = this;
  return q(e, i, "listItemIndent", r.containerState.size + 1);
  function i(l) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "listItemIndent" && o[2].sliceSerialize(o[1], !0).length === r.containerState.size ? n(l) : t(l);
  }
}
function xo(e) {
  e.exit(this.containerState.type);
}
function ko(e, n, t) {
  const r = this;
  return q(e, i, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function i(l) {
    const o = r.events[r.events.length - 1];
    return !M(l) && o && o[1].type === "listItemPrefixWhitespace" ? n(l) : t(l);
  }
}
const mt = {
  name: "setextUnderline",
  resolveTo: bo,
  tokenize: wo
};
function bo(e, n) {
  let t = e.length, r, i, l;
  for (; t--; )
    if (e[t][0] === "enter") {
      if (e[t][1].type === "content") {
        r = t;
        break;
      }
      e[t][1].type === "paragraph" && (i = t);
    } else
      e[t][1].type === "content" && e.splice(t, 1), !l && e[t][1].type === "definition" && (l = t);
  const o = {
    type: "setextHeading",
    start: {
      ...e[r][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[i][1].type = "setextHeadingText", l ? (e.splice(i, 0, ["enter", o, n]), e.splice(l + 1, 0, ["exit", e[r][1], n]), e[r][1].end = {
    ...e[l][1].end
  }) : e[r][1] = o, e.push(["exit", o, n]), e;
}
function wo(e, n, t) {
  const r = this;
  let i;
  return l;
  function l(c) {
    let f = r.events.length, h;
    for (; f--; )
      if (r.events[f][1].type !== "lineEnding" && r.events[f][1].type !== "linePrefix" && r.events[f][1].type !== "content") {
        h = r.events[f][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || h) ? (e.enter("setextHeadingLine"), i = c, o(c)) : t(c);
  }
  function o(c) {
    return e.enter("setextHeadingLineSequence"), a(c);
  }
  function a(c) {
    return c === i ? (e.consume(c), a) : (e.exit("setextHeadingLineSequence"), M(c) ? q(e, s, "lineSuffix")(c) : s(c));
  }
  function s(c) {
    return c === null || v(c) ? (e.exit("setextHeadingLine"), n(c)) : t(c);
  }
}
const So = {
  tokenize: Eo
};
function Eo(e) {
  const n = this, t = e.attempt(
    // Try to parse a blank line.
    Ke,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, i, q(e, e.attempt(this.parser.constructs.flow, i, e.attempt(Al, i)), "linePrefix"))
  );
  return t;
  function r(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(l), e.exit("lineEndingBlank"), n.currentConstruct = void 0, t;
  }
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), n.currentConstruct = void 0, t;
  }
}
const Co = {
  resolveAll: ur()
}, Io = ar("string"), To = ar("text");
function ar(e) {
  return {
    resolveAll: ur(e === "text" ? Ao : void 0),
    tokenize: n
  };
  function n(t) {
    const r = this, i = this.parser.constructs[e], l = t.attempt(i, o, a);
    return o;
    function o(f) {
      return c(f) ? l(f) : a(f);
    }
    function a(f) {
      if (f === null) {
        t.consume(f);
        return;
      }
      return t.enter("data"), t.consume(f), s;
    }
    function s(f) {
      return c(f) ? (t.exit("data"), l(f)) : (t.consume(f), s);
    }
    function c(f) {
      if (f === null)
        return !0;
      const h = i[f];
      let d = -1;
      if (h)
        for (; ++d < h.length; ) {
          const p = h[d];
          if (!p.previous || p.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function ur(e) {
  return n;
  function n(t, r) {
    let i = -1, l;
    for (; ++i <= t.length; )
      l === void 0 ? t[i] && t[i][1].type === "data" && (l = i, i++) : (!t[i] || t[i][1].type !== "data") && (i !== l + 2 && (t[l][1].end = t[i - 1][1].end, t.splice(l + 2, i - l - 2), i = l + 2), l = void 0);
    return e ? e(t, r) : t;
  }
}
function Ao(e, n) {
  let t = 0;
  for (; ++t <= e.length; )
    if ((t === e.length || e[t][1].type === "lineEnding") && e[t - 1][1].type === "data") {
      const r = e[t - 1][1], i = n.sliceStream(r);
      let l = i.length, o = -1, a = 0, s;
      for (; l--; ) {
        const c = i[l];
        if (typeof c == "string") {
          for (o = c.length; c.charCodeAt(o - 1) === 32; )
            a++, o--;
          if (o) break;
          o = -1;
        } else if (c === -2)
          s = !0, a++;
        else if (c !== -1) {
          l++;
          break;
        }
      }
      if (n._contentTypeTextTrailing && t === e.length && (a = 0), a) {
        const c = {
          type: t === e.length || s || a < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: l ? o : r.start._bufferIndex + o,
            _index: r.start._index + l,
            line: r.end.line,
            column: r.end.column - a,
            offset: r.end.offset - a
          },
          end: {
            ...r.end
          }
        };
        r.end = {
          ...c.start
        }, r.start.offset === r.end.offset ? Object.assign(r, c) : (e.splice(t, 0, ["enter", c, n], ["exit", c, n]), t += 2);
      }
      t++;
    }
  return e;
}
const Po = {
  42: te,
  43: te,
  45: te,
  48: te,
  49: te,
  50: te,
  51: te,
  52: te,
  53: te,
  54: te,
  55: te,
  56: te,
  57: te,
  62: er
}, vo = {
  91: Ol
}, _o = {
  [-2]: ln,
  [-1]: ln,
  32: ln
}, Ro = {
  35: Ml,
  42: Ye,
  45: [mt, Ye],
  60: Hl,
  61: mt,
  95: Ye,
  96: pt,
  126: pt
}, Oo = {
  38: tr,
  92: nr
}, zo = {
  [-5]: on,
  [-4]: on,
  [-3]: on,
  33: oo,
  38: tr,
  42: Sn,
  60: [ul, Gl],
  91: uo,
  92: [Dl, nr],
  93: Nn,
  95: Sn,
  96: wl
}, Lo = {
  null: [Sn, Co]
}, No = {
  null: [42, 95]
}, Do = {
  null: []
}, Fo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: No,
  contentInitial: vo,
  disable: Do,
  document: Po,
  flow: Ro,
  flowInitial: _o,
  insideSpan: Lo,
  string: Oo,
  text: zo
}, Symbol.toStringTag, { value: "Module" }));
function Mo(e, n, t) {
  let r = {
    _bufferIndex: -1,
    _index: 0,
    line: t && t.line || 1,
    column: t && t.column || 1,
    offset: t && t.offset || 0
  };
  const i = {}, l = [];
  let o = [], a = [];
  const s = {
    attempt: D(O),
    check: D(x),
    consume: C,
    enter: E,
    exit: N,
    interrupt: D(x, {
      interrupt: !0
    })
  }, c = {
    code: null,
    containerState: {},
    defineSkip: k,
    events: [],
    now: y,
    parser: e,
    previous: null,
    sliceSerialize: d,
    sliceStream: p,
    write: h
  };
  let f = n.tokenize.call(c, s);
  return n.resolveAll && l.push(n), c;
  function h(A) {
    return o = ce(o, A), I(), o[o.length - 1] !== null ? [] : (W(n, 0), c.events = Ln(l, c.events, c), c.events);
  }
  function d(A, T) {
    return jo(p(A), T);
  }
  function p(A) {
    return Bo(o, A);
  }
  function y() {
    const {
      _bufferIndex: A,
      _index: T,
      line: H,
      column: Y,
      offset: z
    } = r;
    return {
      _bufferIndex: A,
      _index: T,
      line: H,
      column: Y,
      offset: z
    };
  }
  function k(A) {
    i[A.line] = A.column, j();
  }
  function I() {
    let A;
    for (; r._index < o.length; ) {
      const T = o[r._index];
      if (typeof T == "string")
        for (A = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === A && r._bufferIndex < T.length; )
          w(T.charCodeAt(r._bufferIndex));
      else
        w(T);
    }
  }
  function w(A) {
    f = f(A);
  }
  function C(A) {
    v(A) ? (r.line++, r.column = 1, r.offset += A === -3 ? 2 : 1, j()) : A !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    o[r._index].length && (r._bufferIndex = -1, r._index++)), c.previous = A;
  }
  function E(A, T) {
    const H = T || {};
    return H.type = A, H.start = y(), c.events.push(["enter", H, c]), a.push(H), H;
  }
  function N(A) {
    const T = a.pop();
    return T.end = y(), c.events.push(["exit", T, c]), T;
  }
  function O(A, T) {
    W(A, T.from);
  }
  function x(A, T) {
    T.restore();
  }
  function D(A, T) {
    return H;
    function H(Y, z, K) {
      let G, ne, se, u;
      return Array.isArray(Y) ? (
        /* c8 ignore next 1 */
        F(Y)
      ) : "tokenize" in Y ? (
        // Looks like a construct.
        F([
          /** @type {Construct} */
          Y
        ])
      ) : P(Y);
      function P(X) {
        return ge;
        function ge($) {
          const le = $ !== null && X[$], pe = $ !== null && X.null, Ce = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(le) ? le : le ? [le] : [],
            ...Array.isArray(pe) ? pe : pe ? [pe] : []
          ];
          return F(Ce)($);
        }
      }
      function F(X) {
        return G = X, ne = 0, X.length === 0 ? K : m(X[ne]);
      }
      function m(X) {
        return ge;
        function ge($) {
          return u = B(), se = X, X.partial || (c.currentConstruct = X), X.name && c.parser.constructs.disable.null.includes(X.name) ? Z() : X.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            T ? Object.assign(Object.create(c), T) : c,
            s,
            Q,
            Z
          )($);
        }
      }
      function Q(X) {
        return A(se, u), z;
      }
      function Z(X) {
        return u.restore(), ++ne < G.length ? m(G[ne]) : K;
      }
    }
  }
  function W(A, T) {
    A.resolveAll && !l.includes(A) && l.push(A), A.resolve && de(c.events, T, c.events.length - T, A.resolve(c.events.slice(T), c)), A.resolveTo && (c.events = A.resolveTo(c.events, c));
  }
  function B() {
    const A = y(), T = c.previous, H = c.currentConstruct, Y = c.events.length, z = Array.from(a);
    return {
      from: Y,
      restore: K
    };
    function K() {
      r = A, c.previous = T, c.currentConstruct = H, c.events.length = Y, a = z, j();
    }
  }
  function j() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function Bo(e, n) {
  const t = n.start._index, r = n.start._bufferIndex, i = n.end._index, l = n.end._bufferIndex;
  let o;
  if (t === i)
    o = [e[t].slice(r, l)];
  else {
    if (o = e.slice(t, i), r > -1) {
      const a = o[0];
      typeof a == "string" ? o[0] = a.slice(r) : o.shift();
    }
    l > 0 && o.push(e[i].slice(0, l));
  }
  return o;
}
function jo(e, n) {
  let t = -1;
  const r = [];
  let i;
  for (; ++t < e.length; ) {
    const l = e[t];
    let o;
    if (typeof l == "string")
      o = l;
    else switch (l) {
      case -5: {
        o = "\r";
        break;
      }
      case -4: {
        o = `
`;
        break;
      }
      case -3: {
        o = `\r
`;
        break;
      }
      case -2: {
        o = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && i) continue;
        o = " ";
        break;
      }
      default:
        o = String.fromCharCode(l);
    }
    i = l === -2, r.push(o);
  }
  return r.join("");
}
function Uo(e) {
  const r = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      Wi([Fo, ...(e || {}).extensions || []])
    ),
    content: i(nl),
    defined: [],
    document: i(rl),
    flow: i(So),
    lazy: {},
    string: i(Io),
    text: i(To)
  };
  return r;
  function i(l) {
    return o;
    function o(a) {
      return Mo(r, l, a);
    }
  }
}
function Ho(e) {
  for (; !rr(e); )
    ;
  return e;
}
const dt = /[\0\t\n\r]/g;
function Vo() {
  let e = 1, n = "", t = !0, r;
  return i;
  function i(l, o, a) {
    const s = [];
    let c, f, h, d, p;
    for (l = n + (typeof l == "string" ? l.toString() : new TextDecoder(o || void 0).decode(l)), h = 0, n = "", t && (l.charCodeAt(0) === 65279 && h++, t = void 0); h < l.length; ) {
      if (dt.lastIndex = h, c = dt.exec(l), d = c && c.index !== void 0 ? c.index : l.length, p = l.charCodeAt(d), !c) {
        n = l.slice(h);
        break;
      }
      if (p === 10 && h === d && r)
        s.push(-3), r = void 0;
      else
        switch (r && (s.push(-5), r = void 0), h < d && (s.push(l.slice(h, d)), e += d - h), p) {
          case 0: {
            s.push(65533), e++;
            break;
          }
          case 9: {
            for (f = Math.ceil(e / 4) * 4, s.push(-2); e++ < f; ) s.push(-1);
            break;
          }
          case 10: {
            s.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      h = d + 1;
    }
    return a && (r && s.push(-5), n && s.push(n), s.push(null)), s;
  }
}
const qo = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $o(e) {
  return e.replace(qo, Yo);
}
function Yo(e, n, t) {
  if (n)
    return n;
  if (t.charCodeAt(0) === 35) {
    const i = t.charCodeAt(1), l = i === 120 || i === 88;
    return Zt(t.slice(l ? 2 : 1), l ? 16 : 10);
  }
  return zn(t) || e;
}
const sr = {}.hasOwnProperty;
function Wo(e, n, t) {
  return typeof n != "string" && (t = n, n = void 0), Xo(t)(Ho(Uo(t).document().write(Vo()(e, n, !0))));
}
function Xo(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: l(qn),
      autolinkProtocol: B,
      autolinkEmail: B,
      atxHeading: l(Un),
      blockQuote: l(pe),
      characterEscape: B,
      characterReference: B,
      codeFenced: l(Ce),
      codeFencedFenceInfo: o,
      codeFencedFenceMeta: o,
      codeIndented: l(Ce, o),
      codeText: l(wr, o),
      codeTextData: B,
      data: B,
      codeFlowValue: B,
      definition: l(Sr),
      definitionDestinationString: o,
      definitionLabelString: o,
      definitionTitleString: o,
      emphasis: l(Er),
      hardBreakEscape: l(Hn),
      hardBreakTrailing: l(Hn),
      htmlFlow: l(Vn, o),
      htmlFlowData: B,
      htmlText: l(Vn, o),
      htmlTextData: B,
      image: l(Cr),
      label: o,
      link: l(qn),
      listItem: l(Ir),
      listItemValue: d,
      listOrdered: l($n, h),
      listUnordered: l($n),
      paragraph: l(Tr),
      reference: m,
      referenceString: o,
      resourceDestinationString: o,
      resourceTitleString: o,
      setextHeading: l(Un),
      strong: l(Ar),
      thematicBreak: l(vr)
    },
    exit: {
      atxHeading: s(),
      atxHeadingSequence: O,
      autolink: s(),
      autolinkEmail: le,
      autolinkProtocol: $,
      blockQuote: s(),
      characterEscapeValue: j,
      characterReferenceMarkerHexadecimal: Z,
      characterReferenceMarkerNumeric: Z,
      characterReferenceValue: X,
      characterReference: ge,
      codeFenced: s(I),
      codeFencedFence: k,
      codeFencedFenceInfo: p,
      codeFencedFenceMeta: y,
      codeFlowValue: j,
      codeIndented: s(w),
      codeText: s(z),
      codeTextData: j,
      data: j,
      definition: s(),
      definitionDestinationString: N,
      definitionLabelString: C,
      definitionTitleString: E,
      emphasis: s(),
      hardBreakEscape: s(T),
      hardBreakTrailing: s(T),
      htmlFlow: s(H),
      htmlFlowData: j,
      htmlText: s(Y),
      htmlTextData: j,
      image: s(G),
      label: se,
      labelText: ne,
      lineEnding: A,
      link: s(K),
      listItem: s(),
      listOrdered: s(),
      listUnordered: s(),
      paragraph: s(),
      referenceString: Q,
      resourceDestinationString: u,
      resourceTitleString: P,
      resource: F,
      setextHeading: s(W),
      setextHeadingLineSequence: D,
      setextHeadingText: x,
      strong: s(),
      thematicBreak: s()
    }
  };
  cr(n, (e || {}).mdastExtensions || []);
  const t = {};
  return r;
  function r(g) {
    let S = {
      type: "root",
      children: []
    };
    const _ = {
      stack: [S],
      tokenStack: [],
      config: n,
      enter: a,
      exit: c,
      buffer: o,
      resume: f,
      data: t
    }, L = [];
    let U = -1;
    for (; ++U < g.length; )
      if (g[U][1].type === "listOrdered" || g[U][1].type === "listUnordered")
        if (g[U][0] === "enter")
          L.push(U);
        else {
          const fe = L.pop();
          U = i(g, fe, U);
        }
    for (U = -1; ++U < g.length; ) {
      const fe = n[g[U][0]];
      sr.call(fe, g[U][1].type) && fe[g[U][1].type].call(Object.assign({
        sliceSerialize: g[U][2].sliceSerialize
      }, _), g[U][1]);
    }
    if (_.tokenStack.length > 0) {
      const fe = _.tokenStack[_.tokenStack.length - 1];
      (fe[1] || gt).call(_, void 0, fe[0]);
    }
    for (S.position = {
      start: ke(g.length > 0 ? g[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: ke(g.length > 0 ? g[g.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, U = -1; ++U < n.transforms.length; )
      S = n.transforms[U](S) || S;
    return S;
  }
  function i(g, S, _) {
    let L = S - 1, U = -1, fe = !1, we, ye, Re, Oe;
    for (; ++L <= _; ) {
      const oe = g[L];
      switch (oe[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          oe[0] === "enter" ? U++ : U--, Oe = void 0;
          break;
        }
        case "lineEndingBlank": {
          oe[0] === "enter" && (we && !Oe && !U && !Re && (Re = L), Oe = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          Oe = void 0;
      }
      if (!U && oe[0] === "enter" && oe[1].type === "listItemPrefix" || U === -1 && oe[0] === "exit" && (oe[1].type === "listUnordered" || oe[1].type === "listOrdered")) {
        if (we) {
          let Ie = L;
          for (ye = void 0; Ie--; ) {
            const xe = g[Ie];
            if (xe[1].type === "lineEnding" || xe[1].type === "lineEndingBlank") {
              if (xe[0] === "exit") continue;
              ye && (g[ye][1].type = "lineEndingBlank", fe = !0), xe[1].type = "lineEnding", ye = Ie;
            } else if (!(xe[1].type === "linePrefix" || xe[1].type === "blockQuotePrefix" || xe[1].type === "blockQuotePrefixWhitespace" || xe[1].type === "blockQuoteMarker" || xe[1].type === "listItemIndent")) break;
          }
          Re && (!ye || Re < ye) && (we._spread = !0), we.end = Object.assign({}, ye ? g[ye][1].start : oe[1].end), g.splice(ye || L, 0, ["exit", we, oe[2]]), L++, _++;
        }
        if (oe[1].type === "listItemPrefix") {
          const Ie = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, oe[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          we = Ie, g.splice(L, 0, ["enter", Ie, oe[2]]), L++, _++, Re = void 0, Oe = !0;
        }
      }
    }
    return g[S][1]._spread = fe, _;
  }
  function l(g, S) {
    return _;
    function _(L) {
      a.call(this, g(L), L), S && S.call(this, L);
    }
  }
  function o() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function a(g, S, _) {
    this.stack[this.stack.length - 1].children.push(g), this.stack.push(g), this.tokenStack.push([S, _ || void 0]), g.position = {
      start: ke(S.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function s(g) {
    return S;
    function S(_) {
      g && g.call(this, _), c.call(this, _);
    }
  }
  function c(g, S) {
    const _ = this.stack.pop(), L = this.tokenStack.pop();
    if (L)
      L[0].type !== g.type && (S ? S.call(this, g, L[0]) : (L[1] || gt).call(this, g, L[0]));
    else throw new Error("Cannot close `" + g.type + "` (" + Fe({
      start: g.start,
      end: g.end
    }) + "): it’s not open");
    _.position.end = ke(g.end);
  }
  function f() {
    return $i(this.stack.pop());
  }
  function h() {
    this.data.expectingFirstListItemValue = !0;
  }
  function d(g) {
    if (this.data.expectingFirstListItemValue) {
      const S = this.stack[this.stack.length - 2];
      S.start = Number.parseInt(this.sliceSerialize(g), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function p() {
    const g = this.resume(), S = this.stack[this.stack.length - 1];
    S.lang = g;
  }
  function y() {
    const g = this.resume(), S = this.stack[this.stack.length - 1];
    S.meta = g;
  }
  function k() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function I() {
    const g = this.resume(), S = this.stack[this.stack.length - 1];
    S.value = g.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function w() {
    const g = this.resume(), S = this.stack[this.stack.length - 1];
    S.value = g.replace(/(\r?\n|\r)$/g, "");
  }
  function C(g) {
    const S = this.resume(), _ = this.stack[this.stack.length - 1];
    _.label = S, _.identifier = Pe(this.sliceSerialize(g)).toLowerCase();
  }
  function E() {
    const g = this.resume(), S = this.stack[this.stack.length - 1];
    S.title = g;
  }
  function N() {
    const g = this.resume(), S = this.stack[this.stack.length - 1];
    S.url = g;
  }
  function O(g) {
    const S = this.stack[this.stack.length - 1];
    if (!S.depth) {
      const _ = this.sliceSerialize(g).length;
      S.depth = _;
    }
  }
  function x() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function D(g) {
    const S = this.stack[this.stack.length - 1];
    S.depth = this.sliceSerialize(g).codePointAt(0) === 61 ? 1 : 2;
  }
  function W() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function B(g) {
    const _ = this.stack[this.stack.length - 1].children;
    let L = _[_.length - 1];
    (!L || L.type !== "text") && (L = Pr(), L.position = {
      start: ke(g.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, _.push(L)), this.stack.push(L);
  }
  function j(g) {
    const S = this.stack.pop();
    S.value += this.sliceSerialize(g), S.position.end = ke(g.end);
  }
  function A(g) {
    const S = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const _ = S.children[S.children.length - 1];
      _.position.end = ke(g.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(S.type) && (B.call(this, g), j.call(this, g));
  }
  function T() {
    this.data.atHardBreak = !0;
  }
  function H() {
    const g = this.resume(), S = this.stack[this.stack.length - 1];
    S.value = g;
  }
  function Y() {
    const g = this.resume(), S = this.stack[this.stack.length - 1];
    S.value = g;
  }
  function z() {
    const g = this.resume(), S = this.stack[this.stack.length - 1];
    S.value = g;
  }
  function K() {
    const g = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const S = this.data.referenceType || "shortcut";
      g.type += "Reference", g.referenceType = S, delete g.url, delete g.title;
    } else
      delete g.identifier, delete g.label;
    this.data.referenceType = void 0;
  }
  function G() {
    const g = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const S = this.data.referenceType || "shortcut";
      g.type += "Reference", g.referenceType = S, delete g.url, delete g.title;
    } else
      delete g.identifier, delete g.label;
    this.data.referenceType = void 0;
  }
  function ne(g) {
    const S = this.sliceSerialize(g), _ = this.stack[this.stack.length - 2];
    _.label = $o(S), _.identifier = Pe(S).toLowerCase();
  }
  function se() {
    const g = this.stack[this.stack.length - 1], S = this.resume(), _ = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, _.type === "link") {
      const L = g.children;
      _.children = L;
    } else
      _.alt = S;
  }
  function u() {
    const g = this.resume(), S = this.stack[this.stack.length - 1];
    S.url = g;
  }
  function P() {
    const g = this.resume(), S = this.stack[this.stack.length - 1];
    S.title = g;
  }
  function F() {
    this.data.inReference = void 0;
  }
  function m() {
    this.data.referenceType = "collapsed";
  }
  function Q(g) {
    const S = this.resume(), _ = this.stack[this.stack.length - 1];
    _.label = S, _.identifier = Pe(this.sliceSerialize(g)).toLowerCase(), this.data.referenceType = "full";
  }
  function Z(g) {
    this.data.characterReferenceType = g.type;
  }
  function X(g) {
    const S = this.sliceSerialize(g), _ = this.data.characterReferenceType;
    let L;
    _ ? (L = Zt(S, _ === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : L = zn(S);
    const U = this.stack[this.stack.length - 1];
    U.value += L;
  }
  function ge(g) {
    const S = this.stack.pop();
    S.position.end = ke(g.end);
  }
  function $(g) {
    j.call(this, g);
    const S = this.stack[this.stack.length - 1];
    S.url = this.sliceSerialize(g);
  }
  function le(g) {
    j.call(this, g);
    const S = this.stack[this.stack.length - 1];
    S.url = "mailto:" + this.sliceSerialize(g);
  }
  function pe() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Ce() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function wr() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Sr() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Er() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function Un() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function Hn() {
    return {
      type: "break"
    };
  }
  function Vn() {
    return {
      type: "html",
      value: ""
    };
  }
  function Cr() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function qn() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function $n(g) {
    return {
      type: "list",
      ordered: g.type === "listOrdered",
      start: null,
      spread: g._spread,
      children: []
    };
  }
  function Ir(g) {
    return {
      type: "listItem",
      spread: g._spread,
      checked: null,
      children: []
    };
  }
  function Tr() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function Ar() {
    return {
      type: "strong",
      children: []
    };
  }
  function Pr() {
    return {
      type: "text",
      value: ""
    };
  }
  function vr() {
    return {
      type: "thematicBreak"
    };
  }
}
function ke(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function cr(e, n) {
  let t = -1;
  for (; ++t < n.length; ) {
    const r = n[t];
    Array.isArray(r) ? cr(e, r) : Go(e, r);
  }
}
function Go(e, n) {
  let t;
  for (t in n)
    if (sr.call(n, t))
      switch (t) {
        case "canContainEols": {
          const r = n[t];
          r && e[t].push(...r);
          break;
        }
        case "transforms": {
          const r = n[t];
          r && e[t].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = n[t];
          r && Object.assign(e[t], r);
          break;
        }
      }
}
function gt(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Fe({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + Fe({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + Fe({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function Qo(e) {
  const n = this;
  n.parser = t;
  function t(r) {
    return Wo(r, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function Jo(e, n) {
  const t = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function Ko(e, n) {
  const t = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, t), [e.applyData(n, t), { type: "text", value: `
` }];
}
function Zo(e, n) {
  const t = n.value ? n.value + `
` : "", r = {};
  n.lang && (r.className = ["language-" + n.lang]);
  let i = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: t }]
  };
  return n.meta && (i.data = { meta: n.meta }), e.patch(n, i), i = e.applyData(n, i), i = { type: "element", tagName: "pre", properties: {}, children: [i] }, e.patch(n, i), i;
}
function ea(e, n) {
  const t = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function na(e, n) {
  const t = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function ta(e, n) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(n.identifier).toUpperCase(), i = _e(r.toLowerCase()), l = e.footnoteOrder.indexOf(r);
  let o, a = e.footnoteCounts.get(r);
  a === void 0 ? (a = 0, e.footnoteOrder.push(r), o = e.footnoteOrder.length) : o = l + 1, a += 1, e.footnoteCounts.set(r, a);
  const s = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + t + "fn-" + i,
      id: t + "fnref-" + i + (a > 1 ? "-" + a : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(o) }]
  };
  e.patch(n, s);
  const c = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [s]
  };
  return e.patch(n, c), e.applyData(n, c);
}
function ra(e, n) {
  const t = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function ia(e, n) {
  if (e.options.allowDangerousHtml) {
    const t = { type: "raw", value: n.value };
    return e.patch(n, t), e.applyData(n, t);
  }
}
function fr(e, n) {
  const t = n.referenceType;
  let r = "]";
  if (t === "collapsed" ? r += "[]" : t === "full" && (r += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + r }];
  const i = e.all(n), l = i[0];
  l && l.type === "text" ? l.value = "[" + l.value : i.unshift({ type: "text", value: "[" });
  const o = i[i.length - 1];
  return o && o.type === "text" ? o.value += r : i.push({ type: "text", value: r }), i;
}
function la(e, n) {
  const t = String(n.identifier).toUpperCase(), r = e.definitionById.get(t);
  if (!r)
    return fr(e, n);
  const i = { src: _e(r.url || ""), alt: n.alt };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const l = { type: "element", tagName: "img", properties: i, children: [] };
  return e.patch(n, l), e.applyData(n, l);
}
function oa(e, n) {
  const t = { src: _e(n.url) };
  n.alt !== null && n.alt !== void 0 && (t.alt = n.alt), n.title !== null && n.title !== void 0 && (t.title = n.title);
  const r = { type: "element", tagName: "img", properties: t, children: [] };
  return e.patch(n, r), e.applyData(n, r);
}
function aa(e, n) {
  const t = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, t);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [t]
  };
  return e.patch(n, r), e.applyData(n, r);
}
function ua(e, n) {
  const t = String(n.identifier).toUpperCase(), r = e.definitionById.get(t);
  if (!r)
    return fr(e, n);
  const i = { href: _e(r.url || "") };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const l = {
    type: "element",
    tagName: "a",
    properties: i,
    children: e.all(n)
  };
  return e.patch(n, l), e.applyData(n, l);
}
function sa(e, n) {
  const t = { href: _e(n.url) };
  n.title !== null && n.title !== void 0 && (t.title = n.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: t,
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function ca(e, n, t) {
  const r = e.all(n), i = t ? fa(t) : pr(n), l = {}, o = [];
  if (typeof n.checked == "boolean") {
    const f = r[0];
    let h;
    f && f.type === "element" && f.tagName === "p" ? h = f : (h = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(h)), h.children.length > 0 && h.children.unshift({ type: "text", value: " " }), h.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), l.className = ["task-list-item"];
  }
  let a = -1;
  for (; ++a < r.length; ) {
    const f = r[a];
    (i || a !== 0 || f.type !== "element" || f.tagName !== "p") && o.push({ type: "text", value: `
` }), f.type === "element" && f.tagName === "p" && !i ? o.push(...f.children) : o.push(f);
  }
  const s = r[r.length - 1];
  s && (i || s.type !== "element" || s.tagName !== "p") && o.push({ type: "text", value: `
` });
  const c = { type: "element", tagName: "li", properties: l, children: o };
  return e.patch(n, c), e.applyData(n, c);
}
function fa(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const t = e.children;
    let r = -1;
    for (; !n && ++r < t.length; )
      n = pr(t[r]);
  }
  return n;
}
function pr(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function pa(e, n) {
  const t = {}, r = e.all(n);
  let i = -1;
  for (typeof n.start == "number" && n.start !== 1 && (t.start = n.start); ++i < r.length; ) {
    const o = r[i];
    if (o.type === "element" && o.tagName === "li" && o.properties && Array.isArray(o.properties.className) && o.properties.className.includes("task-list-item")) {
      t.className = ["contains-task-list"];
      break;
    }
  }
  const l = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: t,
    children: e.wrap(r, !0)
  };
  return e.patch(n, l), e.applyData(n, l);
}
function ha(e, n) {
  const t = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function ma(e, n) {
  const t = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, t), e.applyData(n, t);
}
function da(e, n) {
  const t = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function ga(e, n) {
  const t = e.all(n), r = t.shift(), i = [];
  if (r) {
    const o = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(n.children[0], o), i.push(o);
  }
  if (t.length > 0) {
    const o = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(t, !0)
    }, a = vn(n.children[1]), s = Yt(n.children[n.children.length - 1]);
    a && s && (o.position = { start: a, end: s }), i.push(o);
  }
  const l = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(i, !0)
  };
  return e.patch(n, l), e.applyData(n, l);
}
function ya(e, n, t) {
  const r = t ? t.children : void 0, l = (r ? r.indexOf(n) : 1) === 0 ? "th" : "td", o = t && t.type === "table" ? t.align : void 0, a = o ? o.length : n.children.length;
  let s = -1;
  const c = [];
  for (; ++s < a; ) {
    const h = n.children[s], d = {}, p = o ? o[s] : void 0;
    p && (d.align = p);
    let y = { type: "element", tagName: l, properties: d, children: [] };
    h && (y.children = e.all(h), e.patch(h, y), y = e.applyData(h, y)), c.push(y);
  }
  const f = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(c, !0)
  };
  return e.patch(n, f), e.applyData(n, f);
}
function xa(e, n) {
  const t = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
const yt = 9, xt = 32;
function ka(e) {
  const n = String(e), t = /\r?\n|\r/g;
  let r = t.exec(n), i = 0;
  const l = [];
  for (; r; )
    l.push(
      kt(n.slice(i, r.index), i > 0, !0),
      r[0]
    ), i = r.index + r[0].length, r = t.exec(n);
  return l.push(kt(n.slice(i), i > 0, !1)), l.join("");
}
function kt(e, n, t) {
  let r = 0, i = e.length;
  if (n) {
    let l = e.codePointAt(r);
    for (; l === yt || l === xt; )
      r++, l = e.codePointAt(r);
  }
  if (t) {
    let l = e.codePointAt(i - 1);
    for (; l === yt || l === xt; )
      i--, l = e.codePointAt(i - 1);
  }
  return i > r ? e.slice(r, i) : "";
}
function ba(e, n) {
  const t = { type: "text", value: ka(String(n.value)) };
  return e.patch(n, t), e.applyData(n, t);
}
function wa(e, n) {
  const t = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, t), e.applyData(n, t);
}
const Sa = {
  blockquote: Jo,
  break: Ko,
  code: Zo,
  delete: ea,
  emphasis: na,
  footnoteReference: ta,
  heading: ra,
  html: ia,
  imageReference: la,
  image: oa,
  inlineCode: aa,
  linkReference: ua,
  link: sa,
  listItem: ca,
  list: pa,
  paragraph: ha,
  // @ts-expect-error: root is different, but hard to type.
  root: ma,
  strong: da,
  table: ga,
  tableCell: xa,
  tableRow: ya,
  text: ba,
  thematicBreak: wa,
  toml: Ve,
  yaml: Ve,
  definition: Ve,
  footnoteDefinition: Ve
};
function Ve() {
}
const hr = -1, Ze = 0, Be = 1, Ge = 2, Dn = 3, Fn = 4, Mn = 5, Bn = 6, mr = 7, dr = 8, bt = typeof self == "object" ? self : globalThis, Ea = (e, n) => {
  const t = (i, l) => (e.set(l, i), i), r = (i) => {
    if (e.has(i))
      return e.get(i);
    const [l, o] = n[i];
    switch (l) {
      case Ze:
      case hr:
        return t(o, i);
      case Be: {
        const a = t([], i);
        for (const s of o)
          a.push(r(s));
        return a;
      }
      case Ge: {
        const a = t({}, i);
        for (const [s, c] of o)
          a[r(s)] = r(c);
        return a;
      }
      case Dn:
        return t(new Date(o), i);
      case Fn: {
        const { source: a, flags: s } = o;
        return t(new RegExp(a, s), i);
      }
      case Mn: {
        const a = t(/* @__PURE__ */ new Map(), i);
        for (const [s, c] of o)
          a.set(r(s), r(c));
        return a;
      }
      case Bn: {
        const a = t(/* @__PURE__ */ new Set(), i);
        for (const s of o)
          a.add(r(s));
        return a;
      }
      case mr: {
        const { name: a, message: s } = o;
        return t(new bt[a](s), i);
      }
      case dr:
        return t(BigInt(o), i);
      case "BigInt":
        return t(Object(BigInt(o)), i);
      case "ArrayBuffer":
        return t(new Uint8Array(o).buffer, o);
      case "DataView": {
        const { buffer: a } = new Uint8Array(o);
        return t(new DataView(a), o);
      }
    }
    return t(new bt[l](o), i);
  };
  return r;
}, wt = (e) => Ea(/* @__PURE__ */ new Map(), e)(0), Te = "", { toString: Ca } = {}, { keys: Ia } = Object, De = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [Ze, n];
  const t = Ca.call(e).slice(8, -1);
  switch (t) {
    case "Array":
      return [Be, Te];
    case "Object":
      return [Ge, Te];
    case "Date":
      return [Dn, Te];
    case "RegExp":
      return [Fn, Te];
    case "Map":
      return [Mn, Te];
    case "Set":
      return [Bn, Te];
    case "DataView":
      return [Be, t];
  }
  return t.includes("Array") ? [Be, t] : t.includes("Error") ? [mr, t] : [Ge, t];
}, qe = ([e, n]) => e === Ze && (n === "function" || n === "symbol"), Ta = (e, n, t, r) => {
  const i = (o, a) => {
    const s = r.push(o) - 1;
    return t.set(a, s), s;
  }, l = (o) => {
    if (t.has(o))
      return t.get(o);
    let [a, s] = De(o);
    switch (a) {
      case Ze: {
        let f = o;
        switch (s) {
          case "bigint":
            a = dr, f = o.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + s);
            f = null;
            break;
          case "undefined":
            return i([hr], o);
        }
        return i([a, f], o);
      }
      case Be: {
        if (s) {
          let d = o;
          return s === "DataView" ? d = new Uint8Array(o.buffer) : s === "ArrayBuffer" && (d = new Uint8Array(o)), i([s, [...d]], o);
        }
        const f = [], h = i([a, f], o);
        for (const d of o)
          f.push(l(d));
        return h;
      }
      case Ge: {
        if (s)
          switch (s) {
            case "BigInt":
              return i([s, o.toString()], o);
            case "Boolean":
            case "Number":
            case "String":
              return i([s, o.valueOf()], o);
          }
        if (n && "toJSON" in o)
          return l(o.toJSON());
        const f = [], h = i([a, f], o);
        for (const d of Ia(o))
          (e || !qe(De(o[d]))) && f.push([l(d), l(o[d])]);
        return h;
      }
      case Dn:
        return i([a, o.toISOString()], o);
      case Fn: {
        const { source: f, flags: h } = o;
        return i([a, { source: f, flags: h }], o);
      }
      case Mn: {
        const f = [], h = i([a, f], o);
        for (const [d, p] of o)
          (e || !(qe(De(d)) || qe(De(p)))) && f.push([l(d), l(p)]);
        return h;
      }
      case Bn: {
        const f = [], h = i([a, f], o);
        for (const d of o)
          (e || !qe(De(d))) && f.push(l(d));
        return h;
      }
    }
    const { message: c } = o;
    return i([a, { name: s, message: c }], o);
  };
  return l;
}, St = (e, { json: n, lossy: t } = {}) => {
  const r = [];
  return Ta(!(n || t), !!n, /* @__PURE__ */ new Map(), r)(e), r;
}, Qe = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? wt(St(e, n)) : structuredClone(e)
) : (e, n) => wt(St(e, n));
function Aa(e, n) {
  const t = [{ type: "text", value: "↩" }];
  return n > 1 && t.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), t;
}
function Pa(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function va(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", t = e.options.footnoteBackContent || Aa, r = e.options.footnoteBackLabel || Pa, i = e.options.footnoteLabel || "Footnotes", l = e.options.footnoteLabelTagName || "h2", o = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, a = [];
  let s = -1;
  for (; ++s < e.footnoteOrder.length; ) {
    const c = e.footnoteById.get(
      e.footnoteOrder[s]
    );
    if (!c)
      continue;
    const f = e.all(c), h = String(c.identifier).toUpperCase(), d = _e(h.toLowerCase());
    let p = 0;
    const y = [], k = e.footnoteCounts.get(h);
    for (; k !== void 0 && ++p <= k; ) {
      y.length > 0 && y.push({ type: "text", value: " " });
      let C = typeof t == "string" ? t : t(s, p);
      typeof C == "string" && (C = { type: "text", value: C }), y.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + d + (p > 1 ? "-" + p : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(s, p),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(C) ? C : [C]
      });
    }
    const I = f[f.length - 1];
    if (I && I.type === "element" && I.tagName === "p") {
      const C = I.children[I.children.length - 1];
      C && C.type === "text" ? C.value += " " : I.children.push({ type: "text", value: " " }), I.children.push(...y);
    } else
      f.push(...y);
    const w = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + d },
      children: e.wrap(f, !0)
    };
    e.patch(c, w), a.push(w);
  }
  if (a.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: l,
          properties: {
            ...Qe(o),
            id: "footnote-label"
          },
          children: [{ type: "text", value: i }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(a, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const gr = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return za;
    if (typeof e == "function")
      return en(e);
    if (typeof e == "object")
      return Array.isArray(e) ? _a(e) : Ra(e);
    if (typeof e == "string")
      return Oa(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function _a(e) {
  const n = [];
  let t = -1;
  for (; ++t < e.length; )
    n[t] = gr(e[t]);
  return en(r);
  function r(...i) {
    let l = -1;
    for (; ++l < n.length; )
      if (n[l].apply(this, i)) return !0;
    return !1;
  }
}
function Ra(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return en(t);
  function t(r) {
    const i = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let l;
    for (l in e)
      if (i[l] !== n[l]) return !1;
    return !0;
  }
}
function Oa(e) {
  return en(n);
  function n(t) {
    return t && t.type === e;
  }
}
function en(e) {
  return n;
  function n(t, r, i) {
    return !!(La(t) && e.call(
      this,
      t,
      typeof r == "number" ? r : void 0,
      i || void 0
    ));
  }
}
function za() {
  return !0;
}
function La(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const yr = [], Na = !0, Et = !1, Da = "skip";
function Fa(e, n, t, r) {
  let i;
  typeof n == "function" && typeof t != "function" ? (r = t, t = n) : i = n;
  const l = gr(i), o = r ? -1 : 1;
  a(e, void 0, [])();
  function a(s, c, f) {
    const h = (
      /** @type {Record<string, unknown>} */
      s && typeof s == "object" ? s : {}
    );
    if (typeof h.type == "string") {
      const p = (
        // `hast`
        typeof h.tagName == "string" ? h.tagName : (
          // `xast`
          typeof h.name == "string" ? h.name : void 0
        )
      );
      Object.defineProperty(d, "name", {
        value: "node (" + (s.type + (p ? "<" + p + ">" : "")) + ")"
      });
    }
    return d;
    function d() {
      let p = yr, y, k, I;
      if ((!n || l(s, c, f[f.length - 1] || void 0)) && (p = Ma(t(s, f)), p[0] === Et))
        return p;
      if ("children" in s && s.children) {
        const w = (
          /** @type {UnistParent} */
          s
        );
        if (w.children && p[0] !== Da)
          for (k = (r ? w.children.length : -1) + o, I = f.concat(w); k > -1 && k < w.children.length; ) {
            const C = w.children[k];
            if (y = a(C, k, I)(), y[0] === Et)
              return y;
            k = typeof y[1] == "number" ? y[1] : k + o;
          }
      }
      return p;
    }
  }
}
function Ma(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [Na, e] : e == null ? yr : [e];
}
function xr(e, n, t, r) {
  let i, l, o;
  typeof n == "function" && typeof t != "function" ? (l = void 0, o = n, i = t) : (l = n, o = t, i = r), Fa(e, l, a, i);
  function a(s, c) {
    const f = c[c.length - 1], h = f ? f.children.indexOf(s) : void 0;
    return o(s, h, f);
  }
}
const En = {}.hasOwnProperty, Ba = {};
function ja(e, n) {
  const t = n || Ba, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map(), o = { ...Sa, ...t.handlers }, a = {
    all: c,
    applyData: Ha,
    definitionById: r,
    footnoteById: i,
    footnoteCounts: l,
    footnoteOrder: [],
    handlers: o,
    one: s,
    options: t,
    patch: Ua,
    wrap: qa
  };
  return xr(e, function(f) {
    if (f.type === "definition" || f.type === "footnoteDefinition") {
      const h = f.type === "definition" ? r : i, d = String(f.identifier).toUpperCase();
      h.has(d) || h.set(d, f);
    }
  }), a;
  function s(f, h) {
    const d = f.type, p = a.handlers[d];
    if (En.call(a.handlers, d) && p)
      return p(a, f, h);
    if (a.options.passThrough && a.options.passThrough.includes(d)) {
      if ("children" in f) {
        const { children: k, ...I } = f, w = Qe(I);
        return w.children = a.all(f), w;
      }
      return Qe(f);
    }
    return (a.options.unknownHandler || Va)(a, f, h);
  }
  function c(f) {
    const h = [];
    if ("children" in f) {
      const d = f.children;
      let p = -1;
      for (; ++p < d.length; ) {
        const y = a.one(d[p], f);
        if (y) {
          if (p && d[p - 1].type === "break" && (!Array.isArray(y) && y.type === "text" && (y.value = Ct(y.value)), !Array.isArray(y) && y.type === "element")) {
            const k = y.children[0];
            k && k.type === "text" && (k.value = Ct(k.value));
          }
          Array.isArray(y) ? h.push(...y) : h.push(y);
        }
      }
    }
    return h;
  }
}
function Ua(e, n) {
  e.position && (n.position = Ei(e));
}
function Ha(e, n) {
  let t = n;
  if (e && e.data) {
    const r = e.data.hName, i = e.data.hChildren, l = e.data.hProperties;
    if (typeof r == "string")
      if (t.type === "element")
        t.tagName = r;
      else {
        const o = "children" in t ? t.children : [t];
        t = { type: "element", tagName: r, properties: {}, children: o };
      }
    t.type === "element" && l && Object.assign(t.properties, Qe(l)), "children" in t && t.children && i !== null && i !== void 0 && (t.children = i);
  }
  return t;
}
function Va(e, n) {
  const t = n.data || {}, r = "value" in n && !(En.call(t, "hProperties") || En.call(t, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function qa(e, n) {
  const t = [];
  let r = -1;
  for (n && t.push({ type: "text", value: `
` }); ++r < e.length; )
    r && t.push({ type: "text", value: `
` }), t.push(e[r]);
  return n && e.length > 0 && t.push({ type: "text", value: `
` }), t;
}
function Ct(e) {
  let n = 0, t = e.charCodeAt(n);
  for (; t === 9 || t === 32; )
    n++, t = e.charCodeAt(n);
  return e.slice(n);
}
function It(e, n) {
  const t = ja(e, n), r = t.one(e, void 0), i = va(t), l = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return i && l.children.push({ type: "text", value: `
` }, i), l;
}
function $a(e, n) {
  return e && "run" in e ? async function(t, r) {
    const i = (
      /** @type {HastRoot} */
      It(t, { file: r, ...n })
    );
    await e.run(i, r);
  } : function(t, r) {
    return (
      /** @type {HastRoot} */
      It(t, { file: r, ...e || n })
    );
  };
}
function Tt(e) {
  if (e)
    throw e;
}
var We = Object.prototype.hasOwnProperty, kr = Object.prototype.toString, At = Object.defineProperty, Pt = Object.getOwnPropertyDescriptor, vt = function(n) {
  return typeof Array.isArray == "function" ? Array.isArray(n) : kr.call(n) === "[object Array]";
}, _t = function(n) {
  if (!n || kr.call(n) !== "[object Object]")
    return !1;
  var t = We.call(n, "constructor"), r = n.constructor && n.constructor.prototype && We.call(n.constructor.prototype, "isPrototypeOf");
  if (n.constructor && !t && !r)
    return !1;
  var i;
  for (i in n)
    ;
  return typeof i > "u" || We.call(n, i);
}, Rt = function(n, t) {
  At && t.name === "__proto__" ? At(n, t.name, {
    enumerable: !0,
    configurable: !0,
    value: t.newValue,
    writable: !0
  }) : n[t.name] = t.newValue;
}, Ot = function(n, t) {
  if (t === "__proto__")
    if (We.call(n, t)) {
      if (Pt)
        return Pt(n, t).value;
    } else return;
  return n[t];
}, Ya = function e() {
  var n, t, r, i, l, o, a = arguments[0], s = 1, c = arguments.length, f = !1;
  for (typeof a == "boolean" && (f = a, a = arguments[1] || {}, s = 2), (a == null || typeof a != "object" && typeof a != "function") && (a = {}); s < c; ++s)
    if (n = arguments[s], n != null)
      for (t in n)
        r = Ot(a, t), i = Ot(n, t), a !== i && (f && i && (_t(i) || (l = vt(i))) ? (l ? (l = !1, o = r && vt(r) ? r : []) : o = r && _t(r) ? r : {}, Rt(a, { name: t, newValue: e(f, o, i) })) : typeof i < "u" && Rt(a, { name: t, newValue: i }));
  return a;
};
const an = /* @__PURE__ */ Mt(Ya);
function Cn(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function Wa() {
  const e = [], n = { run: t, use: r };
  return n;
  function t(...i) {
    let l = -1;
    const o = i.pop();
    if (typeof o != "function")
      throw new TypeError("Expected function as last argument, not " + o);
    a(null, ...i);
    function a(s, ...c) {
      const f = e[++l];
      let h = -1;
      if (s) {
        o(s);
        return;
      }
      for (; ++h < i.length; )
        (c[h] === null || c[h] === void 0) && (c[h] = i[h]);
      i = c, f ? Xa(f, a)(...c) : o(null, ...c);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), n;
  }
}
function Xa(e, n) {
  let t;
  return r;
  function r(...o) {
    const a = e.length > o.length;
    let s;
    a && o.push(i);
    try {
      s = e.apply(this, o);
    } catch (c) {
      const f = (
        /** @type {Error} */
        c
      );
      if (a && t)
        throw f;
      return i(f);
    }
    a || (s && s.then && typeof s.then == "function" ? s.then(l, i) : s instanceof Error ? i(s) : l(s));
  }
  function i(o, ...a) {
    t || (t = !0, n(o, ...a));
  }
  function l(o) {
    i(null, o);
  }
}
const he = { basename: Ga, dirname: Qa, extname: Ja, join: Ka, sep: "/" };
function Ga(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  He(e);
  let t = 0, r = -1, i = e.length, l;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; i--; )
      if (e.codePointAt(i) === 47) {
        if (l) {
          t = i + 1;
          break;
        }
      } else r < 0 && (l = !0, r = i + 1);
    return r < 0 ? "" : e.slice(t, r);
  }
  if (n === e)
    return "";
  let o = -1, a = n.length - 1;
  for (; i--; )
    if (e.codePointAt(i) === 47) {
      if (l) {
        t = i + 1;
        break;
      }
    } else
      o < 0 && (l = !0, o = i + 1), a > -1 && (e.codePointAt(i) === n.codePointAt(a--) ? a < 0 && (r = i) : (a = -1, r = o));
  return t === r ? r = o : r < 0 && (r = e.length), e.slice(t, r);
}
function Qa(e) {
  if (He(e), e.length === 0)
    return ".";
  let n = -1, t = e.length, r;
  for (; --t; )
    if (e.codePointAt(t) === 47) {
      if (r) {
        n = t;
        break;
      }
    } else r || (r = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function Ja(e) {
  He(e);
  let n = e.length, t = -1, r = 0, i = -1, l = 0, o;
  for (; n--; ) {
    const a = e.codePointAt(n);
    if (a === 47) {
      if (o) {
        r = n + 1;
        break;
      }
      continue;
    }
    t < 0 && (o = !0, t = n + 1), a === 46 ? i < 0 ? i = n : l !== 1 && (l = 1) : i > -1 && (l = -1);
  }
  return i < 0 || t < 0 || // We saw a non-dot character immediately before the dot.
  l === 0 || // The (right-most) trimmed path component is exactly `..`.
  l === 1 && i === t - 1 && i === r + 1 ? "" : e.slice(i, t);
}
function Ka(...e) {
  let n = -1, t;
  for (; ++n < e.length; )
    He(e[n]), e[n] && (t = t === void 0 ? e[n] : t + "/" + e[n]);
  return t === void 0 ? "." : Za(t);
}
function Za(e) {
  He(e);
  const n = e.codePointAt(0) === 47;
  let t = eu(e, !n);
  return t.length === 0 && !n && (t = "."), t.length > 0 && e.codePointAt(e.length - 1) === 47 && (t += "/"), n ? "/" + t : t;
}
function eu(e, n) {
  let t = "", r = 0, i = -1, l = 0, o = -1, a, s;
  for (; ++o <= e.length; ) {
    if (o < e.length)
      a = e.codePointAt(o);
    else {
      if (a === 47)
        break;
      a = 47;
    }
    if (a === 47) {
      if (!(i === o - 1 || l === 1)) if (i !== o - 1 && l === 2) {
        if (t.length < 2 || r !== 2 || t.codePointAt(t.length - 1) !== 46 || t.codePointAt(t.length - 2) !== 46) {
          if (t.length > 2) {
            if (s = t.lastIndexOf("/"), s !== t.length - 1) {
              s < 0 ? (t = "", r = 0) : (t = t.slice(0, s), r = t.length - 1 - t.lastIndexOf("/")), i = o, l = 0;
              continue;
            }
          } else if (t.length > 0) {
            t = "", r = 0, i = o, l = 0;
            continue;
          }
        }
        n && (t = t.length > 0 ? t + "/.." : "..", r = 2);
      } else
        t.length > 0 ? t += "/" + e.slice(i + 1, o) : t = e.slice(i + 1, o), r = o - i - 1;
      i = o, l = 0;
    } else a === 46 && l > -1 ? l++ : l = -1;
  }
  return t;
}
function He(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const nu = { cwd: tu };
function tu() {
  return "/";
}
function In(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function ru(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!In(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return iu(e);
}
function iu(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const n = e.pathname;
  let t = -1;
  for (; ++t < n.length; )
    if (n.codePointAt(t) === 37 && n.codePointAt(t + 1) === 50) {
      const r = n.codePointAt(t + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(n);
}
const un = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class br {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let t;
    n ? In(n) ? t = { path: n } : typeof n == "string" || lu(n) ? t = { value: n } : t = n : t = {}, this.cwd = "cwd" in t ? "" : nu.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < un.length; ) {
      const l = un[r];
      l in t && t[l] !== void 0 && t[l] !== null && (this[l] = l === "history" ? [...t[l]] : t[l]);
    }
    let i;
    for (i in t)
      un.includes(i) || (this[i] = t[i]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? he.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    cn(n, "basename"), sn(n, "basename"), this.path = he.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? he.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    zt(this.basename, "dirname"), this.path = he.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? he.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (sn(n, "extname"), zt(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = he.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    In(n) && (n = ru(n)), cn(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? he.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    cn(n, "stem"), sn(n, "stem"), this.path = he.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, t, r) {
    const i = this.message(n, t, r);
    throw i.fatal = !0, i;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, t, r) {
    const i = this.message(n, t, r);
    return i.fatal = void 0, i;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, t, r) {
    const i = new ee(
      // @ts-expect-error: the overloads are fine.
      n,
      t,
      r
    );
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function sn(e, n) {
  if (e && e.includes(he.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + he.sep + "`"
    );
}
function cn(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function zt(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function lu(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const ou = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), i = r[e], l = function() {
      return i.apply(l, arguments);
    };
    return Object.setPrototypeOf(l, r), l;
  }
), au = {}.hasOwnProperty;
class jn extends ou {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = Wa();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new jn()
    );
    let t = -1;
    for (; ++t < this.attachers.length; ) {
      const r = this.attachers[t];
      n.use(...r);
    }
    return n.data(an(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, t) {
    return typeof n == "string" ? arguments.length === 2 ? (hn("data", this.frozen), this.namespace[n] = t, this) : au.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (hn("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [t, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const i = t.call(n, ...r);
      typeof i == "function" && this.transformers.use(i);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const t = $e(n), r = this.parser || this.Parser;
    return fn("parse", r), r(String(t), t);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, t) {
    const r = this;
    return this.freeze(), fn("process", this.parser || this.Parser), pn("process", this.compiler || this.Compiler), t ? i(void 0, t) : new Promise(i);
    function i(l, o) {
      const a = $e(n), s = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(a)
      );
      r.run(s, a, function(f, h, d) {
        if (f || !h || !d)
          return c(f);
        const p = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          h
        ), y = r.stringify(p, d);
        cu(y) ? d.value = y : d.result = y, c(
          f,
          /** @type {VFileWithOutput<CompileResult>} */
          d
        );
      });
      function c(f, h) {
        f || !h ? o(f) : l ? l(h) : t(void 0, h);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let t = !1, r;
    return this.freeze(), fn("processSync", this.parser || this.Parser), pn("processSync", this.compiler || this.Compiler), this.process(n, i), Nt("processSync", "process", t), r;
    function i(l, o) {
      t = !0, Tt(l), r = o;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, t, r) {
    Lt(n), this.freeze();
    const i = this.transformers;
    return !r && typeof t == "function" && (r = t, t = void 0), r ? l(void 0, r) : new Promise(l);
    function l(o, a) {
      const s = $e(t);
      i.run(n, s, c);
      function c(f, h, d) {
        const p = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          h || n
        );
        f ? a(f) : o ? o(p) : r(void 0, p, d);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, t) {
    let r = !1, i;
    return this.run(n, t, l), Nt("runSync", "run", r), i;
    function l(o, a) {
      Tt(o), i = a, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, t) {
    this.freeze();
    const r = $e(t), i = this.compiler || this.Compiler;
    return pn("stringify", i), Lt(n), i(n, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...t) {
    const r = this.attachers, i = this.namespace;
    if (hn("use", this.frozen), n != null) if (typeof n == "function")
      s(n, t);
    else if (typeof n == "object")
      Array.isArray(n) ? a(n) : o(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function l(c) {
      if (typeof c == "function")
        s(c, []);
      else if (typeof c == "object")
        if (Array.isArray(c)) {
          const [f, ...h] = (
            /** @type {PluginTuple<Array<unknown>>} */
            c
          );
          s(f, h);
        } else
          o(c);
      else
        throw new TypeError("Expected usable value, not `" + c + "`");
    }
    function o(c) {
      if (!("plugins" in c) && !("settings" in c))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      a(c.plugins), c.settings && (i.settings = an(!0, i.settings, c.settings));
    }
    function a(c) {
      let f = -1;
      if (c != null) if (Array.isArray(c))
        for (; ++f < c.length; ) {
          const h = c[f];
          l(h);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + c + "`");
    }
    function s(c, f) {
      let h = -1, d = -1;
      for (; ++h < r.length; )
        if (r[h][0] === c) {
          d = h;
          break;
        }
      if (d === -1)
        r.push([c, ...f]);
      else if (f.length > 0) {
        let [p, ...y] = f;
        const k = r[d][1];
        Cn(k) && Cn(p) && (p = an(!0, k, p)), r[d] = [c, p, ...y];
      }
    }
  }
}
const uu = new jn().freeze();
function fn(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function pn(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function hn(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Lt(e) {
  if (!Cn(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Nt(e, n, t) {
  if (!t)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function $e(e) {
  return su(e) ? e : new br(e);
}
function su(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function cu(e) {
  return typeof e == "string" || fu(e);
}
function fu(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const pu = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Dt = [], Ft = { allowDangerousHtml: !0 }, hu = /^(https?|ircs?|mailto|xmpp)$/i, mu = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function xu(e) {
  const n = e.allowedElements, t = e.allowElement, r = e.children || "", i = e.className, l = e.components, o = e.disallowedElements, a = e.rehypePlugins || Dt, s = e.remarkPlugins || Dt, c = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...Ft } : Ft, f = e.skipHtml, h = e.unwrapDisallowed, d = e.urlTransform || du, p = uu().use(Qo).use(s).use($a, c).use(a), y = new br();
  typeof r == "string" && (y.value = r);
  for (const C of mu)
    Object.hasOwn(e, C.from) && ("" + C.from + (C.to ? "use `" + C.to + "` instead" : "remove it") + pu + C.id, void 0);
  const k = p.parse(y);
  let I = p.runSync(k, y);
  return i && (I = {
    type: "element",
    tagName: "div",
    properties: { className: i },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      I.type === "root" ? I.children : [I]
    )
  }), xr(I, w), Pi(I, {
    Fragment: nn.Fragment,
    // @ts-expect-error
    // React components are allowed to return numbers,
    // but not according to the types in hast-util-to-jsx-runtime
    components: l,
    ignoreInvalidStyle: !0,
    jsx: nn.jsx,
    jsxs: nn.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function w(C, E, N) {
    if (C.type === "raw" && N && typeof E == "number")
      return f ? N.children.splice(E, 1) : N.children[E] = { type: "text", value: C.value }, E;
    if (C.type === "element") {
      let O;
      for (O in rn)
        if (Object.hasOwn(rn, O) && Object.hasOwn(C.properties, O)) {
          const x = C.properties[O], D = rn[O];
          (D === null || D.includes(C.tagName)) && (C.properties[O] = d(String(x || ""), O, C));
        }
    }
    if (C.type === "element") {
      let O = n ? !n.includes(C.tagName) : o ? o.includes(C.tagName) : !1;
      if (!O && t && typeof E == "number" && (O = !t(C, E, N)), O && N && typeof E == "number")
        return h && C.children ? N.children.splice(E, 1, ...C.children) : N.children.splice(E, 1), E;
    }
  }
}
function du(e) {
  const n = e.indexOf(":"), t = e.indexOf("?"), r = e.indexOf("#"), i = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    i !== -1 && n > i || t !== -1 && n > t || r !== -1 && n > r || // It is a protocol, it should be allowed.
    hu.test(e.slice(0, n)) ? e : ""
  );
}
export {
  xu as M,
  nn as j
};
//# sourceMappingURL=react-markdown-D3zycGHc.js.map
